<template>
    <div v-wechat-title="title" :style="cssVar">
        <el-row type="flex" align="middle">
            <el-col :md="4" :xl="3" class="align-left">
                <span class="hidden-md-and-down">项目类别：</span>
                <item-input type="select" v-model="charge_item_type" :options="charge_item_types" placeholder="项目类别" style="display: inline-block; width: 110px" :clearable="true"></item-input>
            </el-col>
            <el-col :md="3" :xl="2" class="align-left">
                <span class="hidden-md-and-down">类型：</span>
                <item-input type="select" v-model="fee_type" :options="sys_enums.FeeType" placeholder="类型" style="display: inline-block; width: 80px" :clearable="true"></item-input>
            </el-col>
            <el-col :md="4" :xl="3" class="align-left">
                <span class="hidden-md-and-down">状态：</span>
                <item-input type="select" v-model="status" :options="sys_enums.ChargeStatus" placeholder="状态" style="display: inline-block; width: 120px" :clearable="true"></item-input>
            </el-col>
            <el-col :md="13" :xl="16" class="align-right">
                <el-button :type="!this.expeditedStatus ? 'primary' : 'danger' " size="mini" v-if="this.permissions && this.permissions.findIndex(item => item.permission === `charge:expedited`) != -1" @click="changeExpeditedBtnName">  {{ !this.expeditedStatus ? '加急收费' : '取消加急' }}</el-button
                >
                <el-button type="primary" size="mini" v-if="this.permissions && this.permissions.findIndex(item => item.permission === `charge:confirmer`) != -1" @click="confirmerSurgery">
                    确认</el-button
                >
                <el-button type="primary" size="mini" v-if="this.permissions && this.permissions.findIndex(item => item.permission === `charge:ssjf_approval`) != -1" @click="changeApprovalBtnName">
                    {{ !this.approvalStatus ? '审核' : '取消审核' }}</el-button
                >
                <el-dropdown @command="print">
                    <el-button type="primary" size="mini" v-show="ssjfPrint()">打印<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="printChargeItems">{{ this.ssjfPrintBtnName }}</el-dropdown-item>
                        <el-dropdown-item command="printChargeAllItems">{{ this.ssjfPrintAllBtnName }}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-button type="primary" size="mini" @click="printChargeItems" v-if="this.ssjfPrintBtnName != '0' && this.ssjfPrintAllBtnName == '0'">{{ this.ssjfPrintBtnName }}</el-button>
                <el-button type="primary" size="mini" @click="printChargeAllItems" v-if="this.ssjfPrintBtnName == '0' && this.ssjfPrintAllBtnName != '0'">{{ this.ssjfPrintAllBtnName }}</el-button>
                <span v-show="this.ssjfPrintBtnName != `0` || this.ssjfPrintAllBtnName != `0`">&nbsp;|</span>
                <el-button
                    type="primary"
                    :disabled="approvalStatus"
                    size="mini"
                    @click="SyncSurgeryCharge"
                    v-if="this.permissions && this.permissions.findIndex(item => item.permission === `charge:syscssjf`) != -1"
                    >同步</el-button
                >
                <el-button type="primary" size="mini" @click="refreshChargeItems('refresh')">刷新</el-button><span>&nbsp;|</span>
                <el-button type="primary" size="mini" @click="SaveAsTemplate" v-if="this.permissions && this.permissions.findIndex(item => item.permission === `charge:save_astmpssjf`) != -1"
                    >另存为模板</el-button
                >
                <el-button type="primary" size="mini" @click="loadTemplatesView" v-if="this.permissions && this.permissions.findIndex(item => item.permission === `charge:extract_tmpssjf`) != -1"
                    >提取模板</el-button
                >
                <span v-if="this.permissions && this.permissions.findIndex(item => item.permission === `charge:save_astmpssjf` || item.permission === `charge:extract_tmpssjf`) != -1">&nbsp;|</span>
                <el-button
                    type="primary"
                    :disabled="approvalStatus"
                    size="mini"
                    @click="sendHis"
                    v-if="this.permissions && this.permissions.findIndex(item => item.permission === `charge:sendssjf`) != -1"
                    >发送</el-button
                >
                <el-button type="primary" :disabled="approvalStatus" size="mini" @click="withdrawHis" v-if="this.isOpenSHFlow == '1'">撤销</el-button>
                <el-button
                    type="primary"
                    :disabled="approvalStatus"
                    size="mini"
                    @click="loadReturnCharges"
                    v-if="this.permissions && this.permissions.findIndex(item => item.permission === `charge:tfssjf`) != -1"
                    >退费</el-button
                ><span>&nbsp;|</span>
                <el-button
                    type="primary"
                    :disabled="approvalStatus"
                    size="mini"
                    @click="saveItems"
                    v-if="this.permissions && this.permissions.findIndex(item => item.permission === `charge:savessjf`) != -1"
                    >保存</el-button
                >

                <el-popover placement="bottom" :open-delay="600">
                    <el-button size="mini" plain slot="reference">
                        <font-awesome-icon :icon="['fas', 'cog']"></font-awesome-icon>
                        <span class="hidden-md-and-down">&nbsp;列配置</span>
                    </el-button>
                    <el-scrollbar wrap-class="scrollbar-wrapper-y" style="height: 250px; width: 150px">
                        <div class="config-column">
                            <item-input type="checkboxgroup" :options="configColumns" v-model="user_config_columns" ref="configColumnRef"></item-input>
                        </div>
                    </el-scrollbar>

                    <el-divider></el-divider>
                    <div style="text-align: right">
                        <el-link type="primary" :disabled="approvalStatus" size="mini" class="margin-right10" @click="SaveUserColumns">保存</el-link>
                    </div>
                </el-popover>
            </el-col>
        </el-row>
        <!-- 默认 -->
        <el-row class="margin5 margin-none-h" v-show="!this.showRemarksColumnConfig">
            <el-col :lg="10" class="align-left" style="padding-right: 10px"><span class="hidden-md-and-down">手术名称：</span>{{ this.CurrentSurgeries }}</el-col>
            <el-col :lg="3" class="align-left"> 时长：{{ this.surgeryTotal }} </el-col>
            <el-col :lg="2" class="align-left">
                <el-tag :type="surgeryInfo.enum_surgery_type == 1 ? 'danger' : 'primary'" size="mini" v-if="surgeryInfo.enum_surgery_type">{{ surgeryInfo.surgery_type }}</el-tag>
            </el-col>
            <el-col :lg="3" class="align-left"> 类别： {{ (surgeryInfo.visit_info && surgeryInfo.visit_info.pay_type) || '--' }} </el-col>
        </el-row>
        <!-- 存储配置 -->
        <el-row class="margin5 margin-none-h" v-html="this.remarksColumn" v-show="this.showRemarksColumnConfig"></el-row>
        <el-row class="margin5 margin-none-h">
            <el-col :lg="8" class="align-left">
                <span v-show="chargeScanConfig" class="hidden-md-and-down">高值耗材：</span>
                <item-input
                    v-show="chargeScanConfig"
                    ref="scan-code"
                    size="mini"
                    type="scan"
                    v-model="scancode"
                    placeholder="请扫码/输入条形码"
                    style="display: inline-block; width: 200px"
                    :autofocus="true"
                    @input="scanCharge"
                ></item-input>
            </el-col>
            <el-col :lg="this.count" class="align-right" style="font-weight: bold">计费数目:{{ this.totalCount }}</el-col>
            <el-col :lg="4" class="align-right" style="font-weight: bold" :title="titleLabel()" v-if="this.ssjfclassification != '1'"> 已计费用:{{ this.totalPrice }} </el-col>
            <el-col :lg="8" class="align-right" style="font-weight: bold" :title="titleLabel()" v-if="this.ssjfclassification == '1'">
                药品:{{ this.drugsPrice }}&nbsp;非药品:{{ this.otherPrice }}&nbsp;已计费用:{{ this.totalPrice }}
            </el-col>
            <el-col :lg="4" class="align-right" style="color: red; font-weight: bold">已退费用:{{ this.tfPrice }}</el-col>
        </el-row>
        <TreeTable
            :showSequence="false"
            :selection="chargeRefundType == 2"
            @changeColWidth="changeColWidth"
            ref="custtb"
            :datalist="datalist"
            :tableHeight="this.screenHeight - 225 - (this.hasNodes ? 35 : 0)"
            @extrabutton-click="ExtraButtonClick"
            :columns="userListColumn"
            :treeStyle="true"
            :parentField="parentField"
            :autoSelect="false"
            :needEdit="true"
            @select="select"
            @selectAll="selectAll"
            :rowClick="rowClick"
            :headerStyle="tableheaderStyle"
        >
            <!-- <span slot="enum_charge_status" slot-scope="{ row }">
                <i v-if="row.enum_charge_status == 1" :class="{ 'el-icon-circle-check': true, 'fg-primary': row.enum_fee_type == 1, 'fg-danger': row.enum_fee_type == -1 }"> </i>
                <i v-else-if="row.enum_charge_status == 2" :class="{ 'el-icon-circle-close': true, 'fg-primary': row.enum_fee_type == 1, 'fg-danger': row.enum_fee_type == -1 }"></i>
                <i v-else-if="row.enum_charge_status == -1" :class="{ 'el-icon-loading': true, 'fg-primary': row.enum_fee_type == 1, 'fg-danger': row.enum_fee_type == -1 }"></i>
                <i v-else> </i>
            </span> -->
            <template slot="charge_status" slot-scope="{ row }"
                ><div
                    style="white-space: normal"
                    :style="
                        Object.keys(chargeStatusBgColorObj).length > 0 && chargeStatusBgColorObj[row.enum_charge_status] ? 'background-color:' + chargeStatusBgColorObj[row.enum_charge_status] : ''
                    "
                >
                    {{ row.charge_status }}
                </div></template
            >
            <template slot="confirm_status" slot-scope="{ row }"
                ><div style="text-align: center" v-if="row.id > 0">
                    {{ row.confirm_status == true ? '已确认' : '未确认' }}
                </div></template
            >
        </TreeTable>
        <cus-dialog
            ref="form-confirmer"
            class="table-h360"
            title="确认计费项目"
            :data="confirmer.data"
            width="25%"
            :close-on-click-modal="false"
            :visible.sync="confirmer.dialogFormVisible"
            @confirm="submit"
        >
            <el-row style="margin-top: 20px">
                <el-input v-model="confirmer.data.uid" ref="uid" placeholder="请输入用户名" :clearable="true" :autofocus="true">
                    <template slot="prepend">
                        <i class="el-icon-user"></i>
                    </template>
                </el-input>
            </el-row>
            <el-row style="margin-top: 20px">
                <el-input v-model="confirmer.data.pwd" ref="pwd" placeholder="请输入密码" autocomplete="new-password" show-password :clearable="true">
                    <template slot="prepend">
                        <i class="el-icon-lock"></i>
                    </template>
                </el-input>
            </el-row>
        </cus-dialog>
        <form-dialog
            ref="form-saveas"
            title="另存为模板"
            :data="saveas.data"
            width="25%"
            class="form-table-h360"
            :visible.sync="saveas.dialogFormVisible"
            :columns="saveAsColumnList"
            @confirm="SaveAsConfirm"
        ></form-dialog>

        <cus-dialog class="table-h360" title="提取模板" :visible.sync="collectCharges.dialogFormVisible" :close-on-click-modal="false" width="80%" @confirm="addTemplateToList">
            <div v-if="this.charge_template_group && this.charge_template_group.length > 0" :style="{ position: 'relative' }">
                <el-row>
                    <el-col :span="8" class="padding5" style="display: flex; justify-content: flex-start; line-height: 100%">
                        <span style="display: inline-block; width: 30%; line-height: 90%; word-wrap: break-word; white-space: normal; text-align: left">可用范围：</span>
                        <item-input type="radio" v-model="region_type" :options="hasRegionTypePermission"></item-input>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="5" class="padding5" style="display: flex; justify-content: flex-start; line-height: 100%">
                        <item-input type="string1" v-model="region_searchKey" placeholder="请输入关键字" :autofocus="true" @keyup.enter.native="loadTemplatesView"></item-input>
                        <el-button type="primary" size="mini" @click="loadTemplatesView">搜索</el-button>
                    </el-col>
                </el-row>
                <el-row style="min-height: 580px">
                    <el-col :span="5">
                        <el-scrollbar wrap-class="scrollbar-wrapper-y" style="height: 570px; background: white">
                            <el-tree
                                ref="tree"
                                :data="templateTree.data"
                                :props="templateTree.defaultProps"
                                :node-key="templateTree.defaultProps.value"
                                check-on-click-node
                                :default-expand-all="false"
                                @check="handleNodeClick"
                            >
                                <span class="custom-tree-node" slot-scope="{ node, data }"
                                    ><span :title="node.label" :style="{ color: data.is_recovery_template ? '#52b8d2' : '' }">{{ node.label }}</span>
                                </span>
                            </el-tree>
                        </el-scrollbar>
                    </el-col>
                    <el-col :span="19">
                        <TreeTable
                            :showSequence="false"
                            :selection="true"
                            ref="tempItemsTree"
                            :datalist="collectCharges.datalist"
                            :tableHeight="580"
                            :columns="collectChargesColumnList"
                            :treeStyle="true"
                            :parentField="tempItemParentField"
                            :idField="tempItemIdField"
                            :autoSelectParent="false"
                            :autoSelect="false"
                            @select="selectTempItems"
                        >
                        </TreeTable>
                    </el-col>
                </el-row>
            </div>
            <template v-else>
                <div class="padding20 align-left">
                    <span class="line-height35">请选模板:</span>
                    <item-input
                        type="groupselect"
                        :collapseTags="false"
                        v-model="collectCharges.selected_template"
                        :options="collectCharges.charge_template"
                        :clearable="true"
                        style="display: inline-block; width: 300px"
                    ></item-input>
                </div>
                <TreeTable
                    :showSequence="false"
                    :selection="true"
                    ref="tempItemsTree"
                    :datalist="collectCharges.datalist"
                    :tableHeight="this.screenHeight - 186"
                    :columns="collectChargesColumnList"
                    :treeStyle="true"
                    :parentField="tempItemParentField"
                    :idField="tempItemIdField"
                    :autoSelectParent="false"
                    :autoSelect="false"
                    @select="selectTempItems"
                >
                </TreeTable>
            </template>
        </cus-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Sortable from 'sortablejs'
import JSEncrypt from 'jsencrypt/bin/jsencrypt.min'
export default {
    name: `ChargeNew`,
    props: {},
    data() {
        return {
            scancode: ``,
            title: `手术计费`,
            parentField: `parent_id`,
            tempItemParentField: `parentid_guid`,
            tempItemIdField: `id_guid`,
            hasNodes: false,
            chargeType: this.$route.query.charge_type || 0,
            surgeryId: this.$route.query.surgery_id,
            token: this.$route.query.token,
            isOpenSHFlow: this.$root.IsOpenSHFlow,
            record_type: this.$route.query.record_type,
            charge_item_types: [],
            charge_item_type: ``,
            additional_types: [],
            status: ``,
            fee_type: ``,
            datalist: [],
            surgeryInfo: {},
            setDeptByChrgItemType: this.$root.setDeptByChrgItemType,
            chargeStatusBgColor: this.$root.ChargeStatusBgColor,
            chargeStatusBgColorObj: {},
            chargeListStyle: this.$root.chargeListStyle,
            chargeListStyleObj: {},
            chrgItemTypesColorObj: {},
            ssjfPrintBtnName: this.$root.SSJFPrintBtnName,
            ssjfPrintAllBtnName: this.$root.SSJFPrintAllBtnName,
            approvalStatus: false,
            expeditedStatus: false,
            configdefaultPayType: this.$root.DefaultPayType,
            sendJfType: this.$root.SendJfType,
            ssjfclassification: this.$root.ssjfclassification || 0,
            default_pay_type: null,
            default_oper_section_id: null,
            default_oper_section: null,
            default_drug_section_id: null,
            default_drug_section: null,
            default_section_id: null,
            default_section: null,
            default_doctor: null,
            permissions: [],
            collectCharges: {
                dialogFormVisible: false,
                selected_template: undefined,
                charge_template: [],
                datalist: [],
                columnList: []
            },
            confirmer: {
                dialogFormVisible: false,
                data: {
                    uid: ``,
                    pwd: ``
                }
            },
            saveas: {
                dialogFormVisible: false,
                data: {}
            },
            isDrugChargeItemShow: this.$root.isDrugChargeItemShow || 0,
            isDrugAlert: this.$root.isDrugChargeItemShow && this.$root.isDrugChargeItemShow != 0,
            isCanEditSSChrgItem: this.$root.IsCanEditSSChrgItem && this.$root.IsCanEditSSChrgItem == `0`,
            item_configs: [],
            configColumns: [],
            user_config_columns: [],
            user_config_columns2: [],
            chargeRefundType: 2, // 默认批量退
            syncUseDrugIn: false, // 标记是否点击药品同步按钮
            templateIn: false, // 标记是否点击提取模板按钮
            charge_template_selected: false, // 计费模板是否选中
            charge_template_group: this.$root.ChargeTemplateGroup && this.$root.ChargeTemplateGroup != `` && JSON.parse(this.$root.ChargeTemplateGroup) || [],
            templateTree: {
                data: [],
                defaultProps: {
                    value: `value`,
                    children: `children`,
                    label: `label`,
                    parentValue: `parent_value`
                }
            },
            tableName: `api_Nursing/ChargeNew`,
            region_type: 2,
            amountOverNum: 1000,
            chargeScanConfig: (this.$root.carte_ChargeScan && this.$root.carte_ChargeScan != `0`) ? this.$root.carte_ChargeScan : ``,
            autoInputBillDept: this.$root.AutoInputBillDept, // 选择开单科室时 是否把当前选择的值 覆盖到页面其它数据行上,0:不处理,1:把当前选中的值覆盖到其它所有开单科室,2:只覆盖 未赋值的 数据行
            autoInputDoctor: this.$root.AutoInputDoctor, // 选择开单人时 是否把当前选择的值 覆盖到页面其它数据行上,0:不处理,1:把当前选中的值覆盖到其它未保存的数据行,2:覆盖 未发送的 数据行
            defaultPrevRow: this.$root.DefaultPrevRow,
            isChangeBillingDept: this.$root.IsChangeBillingDept, // 选择开单人时,是否开单科室跟着变成开单人的科室
            showRemarksColumnConfig: this.$root.ChargeRemarksColumnConfig && this.$root.ChargeRemarksColumnConfig != `` || false,
            remarksColumn: ``, // 备注栏信息
            charge_Total_Decimaldigits: this.$root.charge_Total_Decimaldigits || 2, // 自定义计费金额小数位数
            amountOverColorInfo: {},
            region_searchKey: ``,
            chargeItemSelectConfig: this.$root.ChargeItemSelectConfig || 0,
            // 0-编码,1-规格,2-价格,3-单位,4-厂商,5-统一收费编码,6-医保类型,7-库存,8-描述
            chargeColumns: [
                { prop: `code`, label: `编码`, minWidth: 150, id: `0` },
                { prop: `spec`, label: `规格`, minWidth: 100, id: `1` },
                { prop: `price`, label: `价格`, minWidth: 80, id: `2` },
                { prop: `sell_unit`, label: `单位`, minWidth: 80, id: `3` },
                { prop: `firm`, label: `厂商`, minWidth: 120, id: `4` },
                { prop: `uni_charge_code`, label: `收费编码`, minWidth: 100, id: `5` },
                { prop: `medical_type`, label: `医保`, minWidth: 80, id: `6` },
                { prop: `inventory`, label: `库存`, minWidth: 80, id: `7` },
                { prop: `description`, label: `描述`, minWidth: 100, id: `8` }
            ],
            onlySimpleWard: this.$root.OnlySimpleWard,
            isConsumableUniqueCode: this.$root.IsConsumableUniqueCode || `0`,
            chargeItemAddConfig: this.$root.ChargeItemAddConfig || `1`,
            themeVersion: 0,
            themeObserver: null
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
            this.$store.dispatch(`ADD_CURRENTUSER`)
        }
        this.$store.dispatch(`ADD_RECOVERY_WARD`)
        this.$store.dispatch(`drug/ADD_DRUG_WAY`)
    },
    computed: {
        ...mapGetters([`ward_auth`, `currentUser`, `recovery_ward_all`, `screenHeight`, `active_ward`, `sys_enums`, `currentSurgery`, `section_auth`, `sysuser/workers_by_duty`, `drug/drug_way`]),
        worker() {
            return this[`sysuser/workers_by_duty`]
        },
        cssVar() {
            const isHisBlue = this.isHisBlueThemeActive(this.themeVersion)
            if (this.chargeListStyle != ``) {
                let ls = eval(`(` + this.chargeListStyle + `)`)
                this.chargeListStyleObj = ls
            }
            const defaultRowBg = isHisBlue ? `#FFFFFF` : `var(--table-row-hover-bg, #cdeae8)`
            const defaultHoverRowBg = isHisBlue ? `var(--table-row-hover-bg, #E1EFFD)` : `var(--table-row-hover-bg, #cdeae8)`
            let rowStyleInfo = (this.chargeListStyleObj && this.chargeListStyleObj.row) || { color: `#000000`, background: defaultRowBg }
            rowStyleInfo = Object.assign({ background: defaultRowBg }, rowStyleInfo)
            if (!rowStyleInfo.background && rowStyleInfo.backgroundColor) {
                rowStyleInfo.background = rowStyleInfo.backgroundColor
            }
            // hover 进入时行样式
            let hoverRowStyleInfo = (this.chargeListStyleObj && this.chargeListStyleObj.hoverRow) || { color: `#000000`, background: defaultHoverRowBg }
            hoverRowStyleInfo = Object.assign({ background: defaultHoverRowBg }, hoverRowStyleInfo)
            if (!hoverRowStyleInfo.background && hoverRowStyleInfo.backgroundColor) {
                hoverRowStyleInfo.background = hoverRowStyleInfo.backgroundColor
            }
            if (isHisBlue) {
                rowStyleInfo = Object.assign({}, rowStyleInfo, { background: defaultRowBg })
                hoverRowStyleInfo = Object.assign({}, hoverRowStyleInfo, { background: defaultHoverRowBg })
            }
            // chrgItemType样式
            let chrgItemTypesColor = this.chargeListStyleObj && this.chargeListStyleObj.chrgItemType
            this.chrgItemTypesColorObj = chrgItemTypesColor
            // 字段校验样式
            let checkFieldsColor = (this.chargeListStyleObj && this.chargeListStyleObj.checkFields) || { amountZeroColor: `#FCA4A4`, payTypeNullColor: `#AAA2FE`, amountOverColor: `1000|#FF0000` }
            let amountOverinfo = checkFieldsColor && checkFieldsColor.amountOverColor && checkFieldsColor.amountOverColor.split(`|`)
            let amountOverColor = `#FF0000`
            if (amountOverinfo && amountOverinfo.length == 2) {
                this.amountOverNum = parseInt(amountOverinfo[0])
                amountOverColor = amountOverinfo && amountOverinfo[1]
            }
            // 计费类型数量校验颜色自定义
            let amountOverColorObj = checkFieldsColor && checkFieldsColor.amountOverColorObj
            this.amountOverColorInfo = amountOverColorObj

            var result = {
                '--rowcolor': rowStyleInfo.color,
                '--rowbgcolor': rowStyleInfo.background,
                '--hoverRowcolor': hoverRowStyleInfo.color,
                '--hoverRowbgcolor': hoverRowStyleInfo.background,
                // 计费类型行颜色自定义
                '--YPColor': chrgItemTypesColor && chrgItemTypesColor.YPColor,
                '--ZLColor': chrgItemTypesColor && chrgItemTypesColor.ZLColor,
                '--QTColor': chrgItemTypesColor && chrgItemTypesColor.QTColor,
                '--HYColor': chrgItemTypesColor && chrgItemTypesColor.HYColor,
                '--JCColor': chrgItemTypesColor && chrgItemTypesColor.JCColor,
                '--ZCColor': chrgItemTypesColor && chrgItemTypesColor.ZCColor,
                '--SSColor': chrgItemTypesColor && chrgItemTypesColor.SSColor,
                '--XFColor': chrgItemTypesColor && chrgItemTypesColor.XFColor,
                '--CLColor': chrgItemTypesColor && chrgItemTypesColor.CLColor,
                '--HLColor': chrgItemTypesColor && chrgItemTypesColor.HLColor,
                '--DZHCColor': chrgItemTypesColor && chrgItemTypesColor.DZHCColor,
                '--FYPColor': chrgItemTypesColor && chrgItemTypesColor.FYPColor,
                '--HCColor': chrgItemTypesColor && chrgItemTypesColor.HCColor,
                '--GZHCColor': chrgItemTypesColor && chrgItemTypesColor.GZHCColor,
                // 计费类型对应数量颜色自定义
                '--YPAmountColor': amountOverColorObj && amountOverColorObj.YP && amountOverColorObj.YP.color,
                '--ZLAmountColor': amountOverColorObj && amountOverColorObj.ZL && amountOverColorObj.ZL.color,
                '--QTAmountColor': amountOverColorObj && amountOverColorObj.QT && amountOverColorObj.QT.color,
                '--HYAmountColor': amountOverColorObj && amountOverColorObj.HY && amountOverColorObj.HY.color,
                '--JCAmountColor': amountOverColorObj && amountOverColorObj.JC && amountOverColorObj.JC.color,
                '--ZCAmountColor': amountOverColorObj && amountOverColorObj.ZC && amountOverColorObj.ZC.color,
                '--SSAmountColor': amountOverColorObj && amountOverColorObj.SS && amountOverColorObj.SS.color,
                '--XFAmountColor': amountOverColorObj && amountOverColorObj.XF && amountOverColorObj.XF.color,
                '--CLAmountColor': amountOverColorObj && amountOverColorObj.CL && amountOverColorObj.CL.color,
                '--HLAmountColor': amountOverColorObj && amountOverColorObj.HL && amountOverColorObj.HL.color,
                '--DZHCAmountColor': amountOverColorObj && amountOverColorObj.DZHC && amountOverColorObj.DZHC.color,
                '--FYPAmountColor': amountOverColorObj && amountOverColorObj.FYP && amountOverColorObj.FYP.color,
                '--HCAmountColor': amountOverColorObj && amountOverColorObj.HC && amountOverColorObj.HC.color,
                '--GZHCAmountColor': amountOverColorObj && amountOverColorObj.GZHC && amountOverColorObj.GZHC.color,
                // 个性化
                '--amountZeroColor': checkFieldsColor && checkFieldsColor.amountZeroColor || `#FCA4A4`,
                '--payTypeNullColor': checkFieldsColor && checkFieldsColor.payTypeNullColor || `#AAA2FE`,
                '--amountOverColor': amountOverColor
            }
            console.log(`result`)
            console.log(result)
            return result
        },
        tableheaderStyle() {
            const isHisBlue = this.isHisBlueThemeActive(this.themeVersion)
            let headerStyle = this.chargeListStyleObj && this.chargeListStyleObj.headerStyle
            if (isHisBlue) {
                return Object.assign({}, headerStyle || {}, {
                    color: `var(--table-header-text, #233A59)`,
                    background: `var(--table-header-bg, #E2E9F2)`,
                    height: `34px`,
                    padding: `0px 0px !important`
                })
            }
            return headerStyle || {
                color: `#fff`,
                background: this.$themePrimary,
                height: `34px`,
                padding: `0px 0px !important`
            }
        },
        fromDesptop() {
            // 是客户端 且 从麻醉单/复苏单打开的返回true(从麻醉单上tab页签过来的 获取计费模板的逻辑和 患者 计费那里提取的逻辑不一样)
            let fromDesptop = false
            if (typeof winformMsg != `undefined` && this.token) {
                fromDesptop = true
            }
            return fromDesptop
        },
        // add by xiaorui ACIS-22558
        // 日期：2021-08-16,
        // 功能：当前用户有区域按钮权限，才显示区域 按钮
        wardOptions() {
            let wards = null
            // ACIS-26427 麻烦啊，当 手术申请 source_hospital_ward_id 不为空,需要根据 来源院区过滤 手术区/复苏区
            if (this.surgeryInfo && this.surgeryInfo.source_hospital_ward_id) {
                wards = _.filter(this.ward_auth, ward => ward.groupId == this.surgeryInfo.source_hospital_ward_id)
            } else {
                wards = _.cloneDeep(this.ward_auth)
                // 是否开启单院区过滤
                if (!this.surgeryId && this.onlySimpleWard == `1`) {
                    // 从科室菜单-用药模版来的且 开启单院区过滤,根据右上角单院区来过滤
                    wards = _.filter(wards, ward => ward.groupId == this.active_ward.groupId)
                }
            }
            let r = []
            if (this.recordType == 2) {
                r = _.filter(wards, (d) => {
                    return _.startsWith(d.value, `rw_`) == true
                })
            } else {
                r = _.filter(wards, (d) => {
                    return _.startsWith(d.value, `ow_`) == true
                })
            }
            console.log(`***********************`)
            console.log(r)
            return r
        },
        hasRegionTypePermission() {
            let r = []
            if (this.onlySimpleWard != `1`) {
                r.push({ label: `个人`, value: 1 })
            }
            if (_.find(this.permissions, { permission: `tmp:area_read` }) != undefined || _.find(this.permissions, { permission: `tmp:area_edit` }) != undefined || _.find(this.permissions, { permission: `tmp:alltmp` }) != undefined) {
                r.push({ label: `区域`, value: 2 })
            }
            return r
        },
        sectionFidlerHospitalWard() {
            let section = _.cloneDeep(this[`section_auth`])
            if (this.surgeryInfo.source_hospital_ward_id != null && this.surgeryInfo.source_hospital_ward_id != ``) {
                section = section.filter(d => d.alias == this.surgeryInfo.source_hospital_ward_id)
            }
            return section
        },
        columnList() {
            let me = this
            let editfailed = (me.permissions && me.permissions.findIndex(item => item.permission === `charge:edit_failed_item_ssjf`) !== -1)
            return [
                { type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isListable: false
                },
                {
                    type: this.chargeItemSelectConfig == 1 ? `tableselect` : `remoteselect`,
                    // type: {
                    //     0: `remoteselect`,
                    //     1: `remoteselecttable`,
                    //     2: `tableselect`
                    // }[this.chargeItemSelectConfig],
                    prop: `chrg_item`,
                    label: `项目名称`,
                    width: `245`,
                    // sortable: true,
                    readonly: function(that, { row, area }) {
                        return (row.enum_charge_status && row.enum_charge_status != 0) || me.chargeItemAddConfig == `0`
                    },
                    options: (that, { row }) => {
                        return q => {
                            return this.loadChargeItemList(q, row)
                        }
                    },
                    selectColumn: this.chargeColumns,
                    change: (that, { row, index }) => {
                        if (row.chrg_item && row.chrg_item.value) {
                            let req = this.myaxios.get(`/api/AcisSystem/ChargeItem/Get/${row.chrg_item.value}`)
                            req.then(data => {
                                // 开启特殊用药弹框提示 且 计费项类型是药品 且 药品Remark有值【remark有值表示特殊用药】
                                if (this.isDrugAlert && data.remark && (this.isDrugChargeItemShow == `1` || (this.isDrugChargeItemShow == `2` && (data.is_special_medication || 0) == 1))) {
                                    this.$confirm(`医保中心提示：该项目 【${row.chrg_item.label}】<br/><br/>${data.remark}<br/><br/>选择【是】将设置为医保，【否】将设置为自费，【X】不开立本医嘱`, `医保中心提示`, {
                                        confirmButtonText: `是`,
                                        cancelButtonText: `否`,
                                        distinguishCancelAndClose: true,
                                        dangerouslyUseHTMLString: true,
                                        closeOnClickModal: false
                                    }).then(() => {
                                        this.$set(row, `enum_pay_type`, 2)// 2=医保
                                    }).catch((action) => {
                                        if (action === `cancel`) {
                                            this.$set(row, `enum_pay_type`, 3) // 3=自费
                                        } else {
                                            this.row = undefined // 取消添加此行
                                        }
                                    })
                                } else {
                                    this.$set(row, `enum_pay_type`, null) // 2=医保
                                    if (!row.enum_pay_type) {
                                        this.$set(row, `enum_pay_type`, this.default_pay_type)
                                    }
                                }
                                this.$set(row, `consumables_batch`, ``)
                                this.$set(row, `special_medication_remark`, null)
                                if (data.remark) {
                                    this.$set(row, `special_medication_remark`, data.remark)
                                }

                                if (!this.isParent(row) &&
                                    (data.level != 2 || data.dic_chrg_item_type_id != 7)) {
                                    this.$set(row, `chrg_item`, {})
                                    this.$message.error(`该项目无法添加为子加收，请重新选择`)
                                    return
                                }
                                this.$set(row, `font_color`, data.font_color)
                                this.$set(row, `chrg_item_type_abbr`, data.chrg_item_type_abbr)
                                if (!this.isMainOperation(row)) {
                                    this.$set(row, `additional_type`, data.additional_type)
                                    this.$set(row, `charg_rate`, data.charg_rate)
                                }
                                if (!_.has(row, `enum_charge_status`) || !row.enum_charge_status) {
                                    this.$set(row, `enum_charge_status`, 0) // 状态 0 未发送
                                }
                                if (!_.has(row, `amount`) || !row.amount) {
                                    this.$set(row, `amount`, 1)
                                }
                                this.$set(row, `enum_fee_type`, 1) // 默认计费
                                this.$set(row, `limit_price_type`, data.limit_price_type)
                                this.$set(row, `min_price`, data.min_price)
                                this.$set(row, `max_price`, data.max_price)
                                this.$set(row, `level`, data.level)
                                this.$set(row, `spec`, data.spec)
                                this.$set(row, `sell_unit`, data.sell_unit) // 计价单位
                                this.$set(row, `price`, data.price) // 单价
                                this.$set(row, `dic_chrg_item_type_id`, data.dic_chrg_item_type_id) // 项目类型id
                                this.$set(row, `is_drug_type`, data.is_drug_type) // 项目类型id
                                this.$set(row, `dic_chrg_item_type`, this.getChargeItemTypeName(data.dic_chrg_item_type_id)) // 项目类型名称
                                if (row.dic_chrg_item_type == `不计费`) {
                                    this.$set(row, `enum_fee_type`, 2) // 默认不计费
                                    // this.$set(row, `total_price`, 0)
                                }
                                this.$set(row, `modifier`, this.currentUser && this.currentUser.dic_worker_name)
                                this.$set(row, `uni_charge_code`, data.uni_charge_code)
                                if (!row.enum_pay_type) {
                                    this.$set(row, `enum_pay_type`, this.default_pay_type)
                                }
                                if (!this.isParent(row)) {
                                    let parent = _.find(this.datalist, x => x.id == row[this.parentField])
                                    if (parent) {
                                        this.setPredataDefault(row, parent)
                                    }
                                } else {
                                    let alldata = this.getAllData()
                                    if (alldata.length <= 1) {
                                        this.setDefaultValue(row)
                                    } else {
                                        let predata = this.getPreData(row)
                                        if (predata) {
                                            this.setPredataDefault(row, predata)
                                        } else {
                                            this.setDefaultValue(row)
                                            if (!row.doctor || !row.billing_dept || !row.execute_dept) {
                                                // ACIS-24801 ,手动输入的项目,如果找不到上一个相同类型的计费项时，直接取上一条数据的开单科室，执行科室等
                                                let predata = alldata[alldata.length - 2]
                                                if (predata) {
                                                    this.setPredataDefault(row, predata)
                                                }
                                            }
                                        }
                                    }
                                }
                                this.$set(row, `billing_time`, me.$moment().format(`YYYY/MM/DD HH:mm`))
                                this.$set(row, `remark`, data.remark)
                                this.$set(row, `remark_msg`, data.remark_msg)
                                this.$set(row, `dic_add_drug_way_id`, data.dic_add_drug_way_id)
                                if (this.isMainOperation(row)) {
                                    if (!row.price) {
                                        this.$message.error(`该手术，单价为空`)
                                        this.$set(row, `class_name`, ` fontredtip`)
                                    }
                                } else if (this.isChildAddition(row)) {
                                    if (!row.price && !row.charg_rate) {
                                        this.$message.error(`该子加收，单价和比例均为空！`)
                                        this.$set(row, `class_name`, `fontredtip`)
                                    }
                                } else if (this.isMainAddition(row)) {
                                    if (!row.price && !row.charg_rate) {
                                        this.$message.error(`该主加收项，单价和比例均为空！`)
                                        this.$set(row, `class_name`, `fontredtip`)
                                    }
                                } else if (!data.price) {
                                    this.$message.error(`该计费项，单价为空！`)
                                    this.$set(row, `class_name`, `fontredtip`)
                                } else {
                                    row.class_name = me.getRowClassName(row)
                                }
                                var lastRow = this.$refs.custtb.getLastRow()
                                if (lastRow.id == row.id) {
                                    this.addParent()
                                }
                                console.log(row, `rowww`)
                            }).catch(e => console.log(e))
                        } else {
                            this.$set(row, `enum_fee_type`, ``)
                            this.$set(row, `enum_charge_status`, ``)
                            this.$set(row, `additional_type`, ``)
                            this.$set(row, `charg_rate`, ``)
                            this.$set(row, `spec`, ``)
                            this.$set(row, `amount`, ``)
                            this.$set(row, `sell_unit`, ``)
                            this.$set(row, `price`, ``)
                            this.$set(row, `dic_chrg_item_type`, ``)
                            this.$set(row, `remark`, ``)
                            this.$set(row, `remark_msg`, ``)
                            this.$set(row, `class_name`, ` charge-row`)
                            this.$set(row, `level`, ``)
                            this.$set(row, `uni_charge_code`, ``)
                            this.$set(row, `limit_price_type`, ``)
                            this.$set(row, `min_price`, ``)
                            this.$set(row, `max_price`, ``)
                            this.$set(row, `dic_add_drug_way_id`, ``)
                            this.$set(row, `consumables_batch`, ``)
                            this.$set(row, `billing_time`, ``)
                        }
                    }
                },
                {
                    type: `select`,
                    prop: `enum_fee_type`,
                    label: `类型`,
                    width: `65`,
                    // sortable: true,
                    options: this.sys_enums.FeeType
                },
                {
                    type: `select`,
                    prop: `enum_charge_status`,
                    label: `状态`,
                    width: `0`,
                    isListable: false,
                    options: this.sys_enums.ChargeStatus
                },
                {
                    type: `custom`,
                    prop: `charge_status`,
                    label: `状态`,
                    width: `80`,
                    // sortable: true,
                    color: `red`
                },
                {
                    type: `select`,
                    prop: `additional_type`,
                    label: `加收类型`,
                    // sortable: true,
                    readonly: function(that, { row, area }) {
                        return !(row.level == 1 && row.dic_chrg_item_type_id == 7)
                    },
                    options: _.map(this.additional_types, d => {
                        return {
                            label: d.additional_type,
                            value: d.additional_type
                        }
                    }),
                    width: `275`,
                    change: (that, { row, index }) => {
                        if (row.additional_type && row.additional_type.length > 0) {
                            let additype = _.find(this.additional_types, x => x.additional_type == row.additional_type)
                            if (!additype) {
                                this.$message.error(`未找到该加收类型，请尝试刷新后重试`)
                                return
                            }
                            if (!additype.charg_rate) {
                                this.$message.error(`该加收类型未配置加收比例，系统默认为1`)
                                additype.charg_rate = 1
                            }
                            this.$set(row, `charg_rate`, additype.charg_rate) // 默认计费
                        } else {
                            this.$set(row, `charg_rate`, 1)
                        }
                    }
                },
                {
                    type: `string`,
                    prop: `spec`,
                    label: `规格`,
                    width: `130`
                },
                {
                    type: `float`,
                    prop: `amount`,
                    label: `计费数量`,
                    sortable: true,
                    width: `90`,
                    // sortable: true,
                    readonly: function(that, { row, area }) {
                        if (row.consumables_batch && me.isConsumableUniqueCode == `1`) {
                            return true
                        }
                        return row.id && row.id > 0 && row.enum_charge_status != 0 && (!editfailed || (editfailed && row.enum_charge_status != 2)) || (me.isCanEditSSChrgItem && row.dic_chrg_item_type == `手术`)
                    },
                    change: (that, { row }) => {
                        if (row.amount && row.amount < 0) { row.amount = 0 }
                        row.class_name = me.getRowClassName(row)
                    }
                },
                {
                    type: `string`,
                    prop: `sell_unit`,
                    label: `计价单位`,
                    width: `68`
                },
                {
                    type: `float`,
                    prop: `charg_rate`,
                    label: `比例`,
                    width: `75`,
                    // sortable: true,
                    format: function(row) {
                        if (!row.charg_rate) {
                            return ``
                        } else {
                            return ((row.charg_rate) * 100).toNewFixed(2) + `%`
                        }
                    }
                },
                {
                    type: `float`,
                    prop: `price`,
                    label: `单价(元)`,
                    width: `90`,
                    // sortable: true,
                    format: function(row) {
                        if (row.isRoot == false && row.charg_rate) {
                            return ``
                        } else {
                            return row.price
                        }
                    },
                    readonly: function(that, { row, area }) {
                        if (row.dic_chrg_item_type == `不计费` || (row.consumables_batch && me.isConsumableUniqueCode == `1`)) {
                            return true
                        }
                        return row.limit_price_type != 1
                    },
                    blur: (that, { row, index }) => {
                        if (row.dic_chrg_item_type == `不计费`) {
                            row.price = 0
                            return
                        }
                        if (row.limit_price_type == 1) {
                            if (row.max_price > 0) {
                                if (row.price > row.max_price) {
                                    row.price = row.max_price
                                    this.$message.warning(`该项目限制单价范围` + row.min_price + `~` + row.max_price)
                                }
                            }
                            if (row.min_price > 0) {
                                if (row.price < row.min_price) {
                                    row.price = row.min_price
                                    this.$message.warning(`该项目限制单价范围` + row.min_price + `~` + row.max_price)
                                }
                            }
                        }
                    }
                },
                {
                    type: `string`,
                    prop: `total_price`,
                    label: `计费金额`,
                    width: `105`,
                    // sortable: true,
                    format: function(row) {
                        if (!row.chrg_item || !row.chrg_item.value) {
                            return ``
                        }
                        return parseFloat(row.total_price)
                    }
                },
                {
                    type: `select`,
                    prop: `dic_chrg_item_type_id`,
                    label: `项目类别`,
                    width: `100`,
                    isListable: true,
                    readonly: true,
                    sortable: true,
                    options: this.charge_item_types,
                    // 自定义排序
                    sortChange: function(that, { a, b, prop, column }) {
                        let thisObj = that.$parent
                        let str1 = a[prop]
                        if (!str1) return 1
                        let str2 = b[prop]
                        if (!str2) return -1
                        let dis1Number = thisObj.DisplayOrderNumber(str1)
                        let dis2Number = thisObj.DisplayOrderNumber(str2)
                        return dis1Number - dis2Number
                    },
                    config: {
                        clearable: false
                    }
                },
                {
                    type: `select`,
                    prop: `dic_add_drug_way_id`,
                    label: `用药途径`,
                    isListable: true,
                    width: `120`,
                    options: this[`drug/drug_way`],
                    readonly: function(that, { row, area }) {
                        return row.id && row.id > 0 && row.enum_charge_status != 0 && (!editfailed || (editfailed && row.enum_charge_status != 2)) || (row.dic_chrg_item_type_id != 1 && !row.is_drug_type)
                    }
                },
                {
                    type: `select`,
                    prop: `enum_pay_type`,
                    label: `收费类别`,
                    width: `90`,
                    options: this.sys_enums.Enum_PayType,
                    // sortable: true,
                    readonly: function(that, { row, area }) {
                        return row.id && row.id > 0 && row.enum_charge_status != 0 && (!editfailed || (editfailed && row.enum_charge_status != 2))
                    },
                    change: (that, { row }) => {
                        row.class_name = me.getRowClassName(row)
                    },
                    config: {
                        clearable: false
                    }
                },
                {
                    type: `remoteselect`,
                    prop: `modifier`,
                    label: `收费人`,
                    width: `80`,
                    // sortable: true,
                    options: (that, { row }) => {
                        return q => {
                            return this.loadWorker(q, row)
                        }
                    },
                    readonly: function(that, { row, area }) {
                        return row.id && row.id > 0 && row.enum_charge_status != 0 && (!editfailed || (editfailed && row.enum_charge_status != 2))
                    }
                },
                {
                    type: `remoteselect`,
                    prop: `doctor`,
                    label: `开单人`,
                    width: `80`,
                    // sortable: true,
                    options: (that, { row }) => {
                        return q => {
                            let doctor = JSON.parse(JSON.stringify(this.worker[`医生`]))
                            let nurse = JSON.parse(JSON.stringify(this.worker[`护士`]))
                            let works = doctor.concat(nurse) || []
                            works.map(d => {
                                d.code = d.card_no + `/` + d.section_name
                            })
                            // let works = this.worker[`医生`] || []
                            if (q && q.keyword) {
                                return works.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return works
                            }
                        }
                    },
                    change: (that, { row }) => {
                        let section = this.sectionFidlerHospitalWard
                        let rowDoctor
                        if (!row.doctor.code) {
                            let doctor = this.worker[`医生`]
                            let nurse = this.worker[`护士`]
                            let works = doctor.concat(nurse) || []
                            let worker = _.find(works, x => x.value == row.doctor.value)
                            rowDoctor = _.find(section, x => x.label == worker.section_name)
                        } else {
                            rowDoctor = _.find(section, x => x.label == row.doctor.section_name)
                        }

                        if (this.isChangeBillingDept == `1`) {
                            this.$set(row, `billing_dept`, rowDoctor)
                        }
                        if ((this.autoInputDoctor != `0`) && row.doctor && row.doctor.label && row.doctor.value) {
                            if (this.autoInputDoctor == `2`) {
                                this.getAllData().forEach(x => {
                                    if (x.chrg_item && x.enum_charge_status == 0) {
                                        this.$set(x, `doctor`, row.doctor)
                                        // ACIS-25349
                                        if (this.isChangeBillingDept == `1`) {
                                            this.$set(x, `billing_dept`, rowDoctor)
                                        }
                                    }
                                })
                            } else {
                                this.getAllData().forEach(x => {
                                    // 通过提取模板添加进来的和手动选择项目新增的 只要没有点击保存，都通过下面这个字段判定为 未保存
                                    if (x.chrg_item && x.pay_type == null && x.pay_type == undefined) {
                                        this.$set(x, `doctor`, row.doctor)
                                        // ACIS-25349
                                        if (this.isChangeBillingDept == `1`) {
                                            this.$set(x, `billing_dept`, rowDoctor)
                                        }
                                    }
                                })
                            }
                        } else {
                            if (row.doctor && row.doctor.label && row.doctor.value) {
                                this.getAllData().forEach(x => {
                                    if (x.chrg_item && (!x.doctor || x.doctor == `0` || !x.doctor.value || x.doctor.value == `0`)) {
                                        this.$set(x, `doctor`, row.doctor)
                                        // ACIS-25349
                                        if (this.isChangeBillingDept == `1`) {
                                            this.$set(x, `billing_dept`, rowDoctor)
                                        }
                                    }
                                })
                            }
                        }
                    },
                    readonly: function(that, { row, area }) {
                        return row.id && row.id > 0 && row.enum_charge_status != 0 && (!editfailed || (editfailed && row.enum_charge_status != 2))
                    }
                },
                {
                    type: `remoteselect`,
                    prop: `billing_dept`,
                    label: `开单科室`,
                    width: `150`,
                    options: (that, { row }) => {
                        return q => {
                            let section = this.sectionFidlerHospitalWard
                            if (q && q.keyword) {
                                return section.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return section
                            }
                        }
                    },
                    change: (that, { row }) => {
                        if ((this.autoInputBillDept != `0`) && row.billing_dept && row.billing_dept.label && row.billing_dept.value) {
                            if (this.autoInputBillDept == `2`) {
                                this.datalist.forEach(x => {
                                    if (x.chrg_item && x.enum_charge_status == 0) {
                                        x.billing_dept = row.billing_dept
                                    }
                                })
                            } else {
                                this.datalist.forEach(x => {
                                    // 通过提取模板添加进来的和手动选择项目新增的 只要没有点击保存，都通过下面这个字段判定为 未保存
                                    if (x.chrg_item && x.pay_type == null && x.pay_type == undefined) {
                                        x.billing_dept = row.billing_dept
                                    }
                                })
                            }
                        }
                    },
                    readonly: function(that, { row, area }) {
                        return row.id && row.id > 0 && row.enum_charge_status != 0 && (!editfailed || (editfailed && row.enum_charge_status != 2))
                    },
                    config: {
                        clearable: false
                    }
                },
                {
                    type: `remoteselect`,
                    prop: `execute_dept`,
                    label: `执行科室`,
                    width: `150`,
                    // sortable: true,
                    options: (that, { row }) => {
                        return q => {
                            let section = []
                            if (row.dic_chrg_item_type_id == 1 || row.is_drug_type) {
                                section = this.drugSections
                            } else {
                                section = this.sectionFidlerHospitalWard
                            }
                            console.log(`执行科室`, section)
                            if (q && q.keyword) {
                                return section.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return section
                            }
                        }
                    },
                    readonly: function(that, { row, area }) {
                        return row.id && row.id > 0 && row.enum_charge_status != 0 && (!editfailed || (editfailed && row.enum_charge_status != 2))
                    },
                    config: {
                        clearable: false
                    }
                }, {
                    type: `datetime`,
                    prop: `billing_time`,
                    label: `收费时间`,
                    width: `180`,
                    default: this.$moment().format(`YYYY/MM/DD HH:mm`),
                    readonly: false,
                    sortable: true,
                    isListable: true
                },
                {
                    type: `bool`,
                    prop: `is_special_medication`,
                    label: `限制性用药`,
                    width: `100`,
                    isListable: true,
                    options: `enum_bool`,
                    readonly: function(that, { row, area }) {
                        return row.id && row.id > 0 && row.enum_charge_status != 0 && (!editfailed || (editfailed && row.enum_charge_status != 2))
                    },
                    default: false
                },
                {
                    type: `string`,
                    prop: `special_medication_remark`, // 限制性用药备注
                    label: `限制性用药备注`,
                    isListable: true,
                    tooltip: true,
                    readonly: function(that, { row, area }) {
                        return row.id && row.id > 0 && row.enum_charge_status != 0 && (!editfailed || (editfailed && row.enum_charge_status != 2))
                    },
                    width: `150`
                },
                {
                    type: `custom`,
                    prop: `confirm_status`,
                    label: `确认状态`,
                    width: `100`,
                    readonly: true,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `confirmer`,
                    label: `确认人`,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `confirm_time`,
                    label: `确认时间`,
                    width: `120`,
                    readonly: true,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `remark`,
                    label: `发送备注`,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `remark_msg`,
                    readonly: function(that, { row, area }) {
                        return row.id && row.id > 0 && row.enum_charge_status != 0 && (!editfailed || (editfailed && row.enum_charge_status != 2))
                    },
                    label: `备注`,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `uni_charge_code`,
                    label: `统一收费编码`,
                    width: `100`,
                    readonly: true,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `his_code`,
                    label: `His编码`,
                    readonly: true,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `number`,
                    prop: `display_order`,
                    label: `排序`,
                    width: `80`,
                    isListable: true,
                    readonly: (that, { row }) => {
                        return row.enum_charge_status && row.enum_charge_status != 0 && (!editfailed || (editfailed && row.enum_charge_status != 2))
                    }
                },
                {
                    type: `string`,
                    prop: `consumables_batch`,
                    label: `高值耗材编号`,
                    width: `140`,
                    readonly: function(that, { row, area }) {
                        return me.chargeScanConfig || (!me.chargeScanConfig && row.id && row.id > 0 && row.enum_charge_status != 0 && (!editfailed || (editfailed && row.enum_charge_status != 2)))
                    },
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `creator`,
                    label: `创建人`,
                    width: `180`,
                    readonly: true,
                    isListable: true
                }, {
                    type: `datetime`,
                    prop: `create_date`,
                    label: `创建时间`,
                    readonly: true,
                    width: `180`,
                    isListable: true
                }, {
                    type: `datetime`,
                    prop: `modify_date`,
                    label: `修改时间`,
                    readonly: true,
                    width: `180`,
                    isListable: true
                }, {
                    type: `datetime`,
                    prop: `submit_date`,
                    label: `发送时间`,
                    sortable: true,
                    readonly: true,
                    width: `180`,
                    isListable: true
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    fixed: `right`,
                    width: `120`,
                    options: (that, { row }) => {
                        var btns = []
                        var lastRow = this.$refs.custtb.getLastRow()
                        if (row.id == lastRow.id && row.rowStatus == 1) {
                            return btns
                        }
                        let delfailed = (me.permissions && me.permissions.findIndex(item => item.permission === `charge:delete_failed_item_ssjf`) !== -1)
                        if (!row.enum_charge_status || row.enum_charge_status == 0 || (row.enum_charge_status == 2 && delfailed)) {
                            btns.push({ label: `删除`, type: `danger`, emit: `removeItem`, permission: `default`, class: `is-plain` })
                        }
                        return btns
                    }
                }
            ]
        },
        regionTypeOption() {
            let r = []
            if (this.onlySimpleWard != `1`) {
                r.push({ label: `个人`, value: 1 })
            }
            r.push({ label: `区域`, value: 2 })
            return r
        },
        saveAsColumnList() {
            let me = this
            let cols = [
                {
                    type: `string`,
                    prop: `name`,
                    label: `名称`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    rowspan: 1,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `radio`,
                    prop: `region_type`,
                    label: `可用范围`,
                    width: `100`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    rowspan: 1,
                    options: this.regionTypeOption,
                    default: 2,
                    change: (that, { row }) => {
                        if (row.region_type == 2) {
                            if (!row.dic_ward_ids) {
                                var ids = []
                                if (me.surgeryInfo && me.surgeryInfo.source_hospital_ward_id > 0) {
                                    ids.push(this.wardOptions && this.wardOptions.length > 0 && this.wardOptions[0].value)
                                } else {
                                    ids.push(this.active_ward.value)
                                }
                                row.dic_ward_ids = ids
                            }
                        }
                    }
                }
            ]
            let regionTypeColIndex = this.charge_template_group.length > 0 ? 2 : 1
            if (this.charge_template_group.length > 0) {
                cols.splice(1, 0,
                    {
                        type: `select`,
                        prop: `group_id`,
                        label: `分组`,
                        isListable: true,
                        isExpand: false,
                        isEditable: true,
                        isCreatable: true,
                        searchable: true,
                        rowspan: 1,
                        options: this.charge_template_group
                    })
            }
            let editpermission = _.find(this.permissions, x => x.permission == `tmp:area_edit`)
            let readpermission = _.find(this.permissions, x => x.permission == `tmp:area_read`)
            let allpermission = _.find(this.permissions, x => x.permission == `tmp:alltmp`)
            if ((readpermission && editpermission) || allpermission) {
                cols[regionTypeColIndex].options = this.regionTypeOption
                cols.push({
                    type: `groupmultiselect`,
                    prop: `dic_ward_ids`,
                    label: `可用区域`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true,
                    rowspan: 1,
                    options: this.wardOptions,
                    readonly: function(that, { row, column, area }) {
                        if (area == `form`) {
                            return row.region_type === 1
                        } else {
                            return true
                        }
                    }
                })
            } else {
                cols[regionTypeColIndex].options = _.filter(this.regionTypeOption, x => x.label == `个人` || x.value == 1)
            }
            return cols
        },
        collectChargesColumnList() {
            return [
                { type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isListable: false
                },
                {
                    type: `string`,
                    prop: `display_order`,
                    label: `排序`,
                    width: `80`,
                    isListable: true
                },
                {
                    type: `remoteselect`,
                    prop: `chrg_item`,
                    label: `项目名称`,
                    // width: `230`,
                    readonly: true,
                    options: (that, { row }) => {
                        return q => {
                            return this.loadChargeItemList(q, row)
                        }
                    }
                },
                {
                    type: `string`,
                    prop: `additional_type`,
                    label: `加收类型`
                    // width: `170`
                },
                {
                    type: `string`,
                    prop: `spec`,
                    label: `规格`,
                    width: `140`
                },
                {
                    type: `float`,
                    prop: `amount`,
                    label: `计费数量`,
                    width: `68`,
                    readonly: false
                },
                {
                    type: `string`,
                    prop: `sell_unit`,
                    label: `计价单位`,
                    width: `68`
                },
                {
                    type: `float`,
                    prop: `charg_rate`,
                    label: `比例`,
                    width: `70`,
                    format: function(row) {
                        if (row.charg_rate == null || row.charg_rate == 0) { return `` } else { return (row.charg_rate) * 100 + `%` }
                    }
                },
                {
                    type: `string`,
                    prop: `price`,
                    label: `单价(元)`,
                    width: `70`
                },
                {
                    type: `string`,
                    prop: `total_price`,
                    label: `计费金额`,
                    width: `100`
                },
                {
                    type: `string`,
                    prop: `dic_chrg_item_type`,
                    label: `项目类别`,
                    width: `80`
                }
                // {
                //     type: `select`,
                //     prop: `execute_dept`,
                //     label: `执行科室`,
                //     width: `100`,
                //     // options: this[`section_auth`],
                //     readonly: true,
                //     options: (that, { row }) => {
                //         if (row.dic_chrg_item_type_id == 1) {
                //             return this.drugSections
                //         } else {
                //             return this.section_auth
                //         }
                //     }
                // }
            ]
        },
        drugSections() {
            let section = this.sectionFidlerHospitalWard
            if (this.surgeryInfo.source_hospital_ward_id != null && this.surgeryInfo.source_hospital_ward_id != ``) {
                section = section.filter(d => d.alias == this.surgeryInfo.source_hospital_ward_id)
            }
            if (section && section.length > 0) {
                var yaofang = []
                let other = []
                for (let item of section) {
                    if (!item.disabled) {
                        if (item.label.indexOf(`药房`) >= 0) {
                            yaofang.push(item)
                        } else {
                            other.push(item)
                        }
                    }
                }
                return yaofang.concat(other)
            }
            return []
        },
        surgeryTotal() {
            let t1 = this.surgeryInfo && this.surgeryInfo.operation_begin && this.$moment(this.surgeryInfo.operation_begin)
            let t2 = this.surgeryInfo && this.surgeryInfo.operation_end && this.$moment(this.surgeryInfo.operation_end)
            if (this.$route.query.charge_type == 102) {
                t1 = this.surgeryInfo && this.surgeryInfo.in_recovery && this.$moment(this.surgeryInfo.in_recovery)
                t2 = this.surgeryInfo && this.surgeryInfo.out_recovery && this.$moment(this.surgeryInfo.out_recovery)
            }
            if (t1 && t2) {
                let ms = t2.diff(t1, `seconds`, true)
                return `${Math.floor(ms / 3600)} h ${Math.floor((ms % 3600) / 60)} min`
            }
            return `--`
        },
        anesTotal() {
            let t1 = this.surgeryInfo && this.surgeryInfo.anesthesia_begin && this.$moment(this.surgeryInfo.anesthesia_begin)
            let t2 = this.surgeryInfo && this.surgeryInfo.anesthesia_end && this.$moment(this.surgeryInfo.anesthesia_end)
            if (this.$route.query.charge_type == 202) {
                t1 = this.surgeryInfo && this.surgeryInfo.in_recovery && this.$moment(this.surgeryInfo.in_recovery)
                t2 = this.surgeryInfo && this.surgeryInfo.out_recovery && this.$moment(this.surgeryInfo.out_recovery)
            }
            if (t1 && t2) {
                let ms = t2.diff(t1, `seconds`, true)
                return `${Math.floor(ms / 3600)} h ${Math.floor((ms % 3600) / 60)} min`
            }
            return `--`
        },
        totalPrice() {
            let sum = 0

            this.getAllData().forEach(x => {
                if (x.total_price && x.total_price > 0 && x.enum_fee_type == 1) {
                    sum += parseFloat(x.total_price)
                }
            })
            return sum.toNewFixed(this.charge_Total_Decimaldigits)
        },
        count() {
            let result = 8
            if (this.ssjfclassification == `1`) {
                result = 4
            }
            return result
        },
        drugsPrice() {
            let sum = 0
            this.getAllData().forEach(x => {
                if (x.total_price && x.total_price > 0 && x.enum_fee_type == 1 && x.is_drug_type) {
                    sum += parseFloat(x.total_price)
                }
            })
            return sum.toNewFixed(this.charge_Total_Decimaldigits)
        },
        otherPrice() {
            let sum = 0
            this.getAllData().forEach(x => {
                if (x.total_price && x.total_price > 0 && x.enum_fee_type == 1 && !x.is_drug_type) {
                    sum += parseFloat(x.total_price)
                }
            })
            return sum.toNewFixed(this.charge_Total_Decimaldigits)
        },
        totalCount() {
            let num = 0
            this.getAllData().forEach(x => {
                if (x.enum_fee_type == 1) {
                    num++
                }
            })
            return num
        },
        tfPrice() {
            let sum = 0
            this.getAllData().forEach(x => {
                if (x.total_price && x.total_price > 0 && x.enum_fee_type != 1) {
                    sum += parseFloat(x.total_price)
                }
            })
            return sum.toNewFixed(this.charge_Total_Decimaldigits)
        },
        userListColumn() {
            let that = this
            if (this.configColumns.length == 0) {
                return this.columnList
            } else if (this.user_config_columns.length == 0) {
                // added by xiaorui,默认如果用户没有配置任何列 则 1.列配置勾选上当前页面所有列 2.展示当前列表上所有列
                that.user_config_columns = that.configColumns.map(c => c.value)
                return this.columnList
            }
            let allcolumn = _.filter(this.columnList, c => {
                return _.includes(this.user_config_columns, c.prop) || c.isExpand || c.isKey || (c.isDisplayOrder && c.isListable)
            })
            allcolumn.map(d => {
                let f = that.user_config_columns2.find(s => s.col_name == d.prop)
                if (f && f.col_width > 0) {
                    d.width = f.col_width
                }
            })
            let r = _.orderBy(allcolumn, function(ac) {
                let i = _.findIndex(that.configColumns, { value: ac.prop })
                return i
            })
            return r
        },
        OperationTotalPrice() {
            let sum = 0
            this.datalist.forEach(data => {
                if (this.isMainOperation(data) && data.enum_fee_type == 1) {
                    sum += parseFloat(data.total_price)
                }
            })
            return sum
        },
        CurrentSurgeries() {
            let surgeries = ``
            if (this.surgeryInfo) {
                if (this.surgeryInfo.fact_summary && this.surgeryInfo.fact_summary.surgery && this.surgeryInfo.fact_summary.surgery.trim() != ``) {
                    surgeries = this.surgeryInfo.fact_summary.surgery
                } else if (this.surgeryInfo.plan_summary && this.surgeryInfo.plan_summary.surgery && this.surgeryInfo.plan_summary.surgery.trim() != ``) {
                    surgeries = this.surgeryInfo.plan_summary.surgery
                }
            }
            return surgeries
        },
        titleLabel() {
            return function() {
                let sumDrugFee = 0
                let sumNoDrugFee = 0
                this.getAllData().forEach(x => {
                    if (x.total_price && x.total_price > 0 && x.enum_fee_type == 1) {
                        if (x.dic_chrg_item_type_id == 1 || x.is_drug_type) { sumDrugFee += parseFloat(x.total_price) } else { sumNoDrugFee += parseFloat(x.total_price) }
                    }
                })
                sumDrugFee = sumDrugFee.toNewFixed(2)
                sumNoDrugFee = sumNoDrugFee.toNewFixed(2)
                let title = `药品费:${sumDrugFee}
非药品费:${sumNoDrugFee}`
                return title
            }
        }
    },
    mounted() {
        this.setupThemeObserver()
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
            this.$store.dispatch(`ADD_CURRENTUSER`)
            console.log(this.$root.chargeListStyle, `this.$root.chargeListStyle`)
        }
        this.loadPermissions()
        this.loadConfigs().then(() => {
            this.loadChargeItemTypes().then(() => {
                this.loadTransportNodes()
                this.loadSurgery().then(() => {
                    this.loadChargeItems()
                })
            })
        })
        //  加载所有枚举
        this.$store.dispatch(`sysuser/ADD_WORKERS`)
        this.$store.dispatch(`enums/ADD_ALL_ENUM`)
        this.$store.dispatch(`ADD_WARD_AUTH`)
        // this.$store.dispatch("drug/ADD_DRUG_TYPE")
        this.$store.dispatch(`ADD_SECTION_AUTH`)

        // 加载配置列
        this.LoadUserColumns()
        this.configColumnDrop()
        if (this.chargeStatusBgColor != ``) {
            let t = eval(
                `(` + this.chargeStatusBgColor + `)`
            )
            this.chargeStatusBgColorObj = t
            console.log(Object.keys(this.chargeStatusBgColorObj).length)
        }
        // 备注栏信息配置
        this.getRemarksColumn()
    },
    beforeDestroy() {
        if (this.themeObserver) {
            this.themeObserver.disconnect()
            this.themeObserver = null
        }
    },
    inject: [`reload`],
    methods: {
        isHisBlueThemeActive(themeVersion) {
            let currentTheme = localStorage.getItem(`app_theme`) || ``
            let bodyHasBlue = document.body && document.body.classList && document.body.classList.contains(`theme-his-blue`)
            return currentTheme === `theme-his-blue` || bodyHasBlue
        },
        setupThemeObserver() {
            if (typeof MutationObserver === `undefined` || !document.body) return
            if (this.themeObserver) {
                this.themeObserver.disconnect()
                this.themeObserver = null
            }
            this.themeObserver = new MutationObserver(() => {
                this.themeVersion += 1
            })
            this.themeObserver.observe(document.body, { attributes: true, attributeFilter: [`class`] })
        },
        isGreenToneColor(colorValue) {
            if (!colorValue || typeof colorValue !== `string`) return false
            const color = colorValue.replace(/\s+/g, ``).toLowerCase()
            if (/^#0{0,2}9688/.test(color)) return true
            if (/^#33aba0/.test(color)) return true
            if (/^#26a69a/.test(color)) return true
            if (color.includes(`rgb(0,150,136)`)) return true
            if (color.includes(`rgba(0,150,136`)) return true
            if (color.includes(`rgb(51,171,160)`)) return true
            if (color.includes(`rgba(51,171,160`)) return true
            if (color.includes(`green`) || color.includes(`teal`)) return true
            return false
        },
        loadTransportNodes() {
            var that = this
            if (that.surgeryId && that.surgeryId > 0) {
                let req = this.myaxios.get(`/api/Nursing/PatientTransport/GetProcSurgeryTransport/${that.surgeryId}`)
                req.then(data => {
                    if (data && data.length > 0) {
                        that.hasNodes = true
                    }
                }).catch(e => {
                    console.log(e)
                })
            }
        },
        // 事件方法
        getReload() {
            this.reload() // 重置刷新
        },
        getRemarksColumn() {
            var that = this
            if (that.surgeryId && that.surgeryId > 0) {
                let req = this.myaxios.get(`/api/Nursing/Charge/GetRemarksColumn?surgeryId=${that.surgeryId}&chargeType=${that.chargeType}`)
                req.then(data => {
                    if (data) {
                        console.log(data)
                        that.showRemarksColumnConfig = true
                        that.remarksColumn = data
                    } else {
                        that.showRemarksColumnConfig = false
                    }
                }).catch(e => {
                    console.log(e)
                    that.showRemarksColumnConfig = false
                })
            } else {
                that.showRemarksColumnConfig = false
            }
        },
        getRowClassName(row) {
            let that = this
            let className = ` charge-row`
            if (row.enum_pay_type == null) {
                className += ` charge-row fontpayTypeNull`
            } else if (row.amount == 0) {
                className += ` charge-row fontamountZero`
            } else if (row.chrg_item_type_abbr && that.chrgItemTypesColorObj) {
                className += ` charge-row font${row.chrg_item_type_abbr}`
            } else if (row.font_color && row.font_color != ``) {
                className += ` charge-row font${row.font_color}`
            }
            // 数量样式
            if (this.amountOverColorInfo && row.chrg_item_type_abbr && this.amountOverColorInfo[`${row.chrg_item_type_abbr}`]) {
                let amount = this.amountOverColorInfo[`${row.chrg_item_type_abbr}`].amount
                if (amount && row.amount >= amount && this.amountOverColorInfo[`${row.chrg_item_type_abbr}`].color) {
                    className += ` font${row.chrg_item_type_abbr}AmounOver`
                }
            } else if (row.amount >= that.amountOverNum) {
                className += ` fontamounOver`
            }

            if (that.isChildAddition(row)) {
                className = className.replace(` charge-row`, ``)
            }
            return className
        },
        print(command) {
            let that = this
            if (command == `printChargeItems`) {
                that.printChargeItems()
            }
            if (command == `printChargeAllItems`) {
                that.printChargeAllItems()
            }
        },
        ssjfPrint() {
            return this.ssjfPrintBtnName != `0` && this.ssjfPrintAllBtnName != `0`
        },
        confirmerSurgery() {
            let that = this
            if (this.chargeRefundType != 1) {
                let selectRows = that.$refs.custtb.getSelectedRows()
                let data1 = _.filter(selectRows, d => (d.id > 0))
                if (!data1 || data1.length == 0) {
                    this.$message.warning(`请选择确认项目`)
                    return
                }
            } else {
                let allrows = that.$refs.custtb.getAllRows()
                let data = _.filter(allrows, d => (d.id > 0))
                if (!data || data.length == 0) {
                    this.$message.warning(`没有需要确认的项目,请保存后再确认`)
                    return
                }
            }
            this.confirmer.dialogFormVisible = true
        },
        changeExpeditedBtnName() {
            this.$confirm(`是否确定${this.expeditedStatus ? `取消加急收费` : `加急收费`}?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let req = this.myaxios.put(`/api/Nursing/Charge/ChangeExpeditedStatus?surgeryId=${this.surgeryId}&chargeType=${this.chargeType}&expeditedStatus=${!this.expeditedStatus}`)
                req.then(data => {
                    this.loadSurgerybody()
                }).catch(e => {
                    console.log(e)
                })
            }).catch(e => { })
        },
        changeApprovalBtnName() {
            let approvalStatus = this.approvalStatus ? 0 : 1
            let data = _.filter(this.datalist, d => d.enum_charge_status)
            if (data && data.length == 0) {
                this.$alert(`没有审核项目`, `提醒`, {
                    dangerouslyUseHTMLString: true,
                    type: `warning`
                })
                return
            }
            if (approvalStatus == 1) {
                // 看看有没有计费成功和退费成功以外其它状态，有 审批时弹框提示，不能审批
                let allchargenosucess = data &&
                        _.filter(data, d => { return ((d.enum_charge_status != 1) && (d.enum_charge_status != 3) && (d.enum_fee_type == 1)) })
                if (allchargenosucess.length > 0) {
                    this.$alert(`所有项目都计费成功和退费成功才能审核`, `提醒`, {
                        dangerouslyUseHTMLString: true,
                        type: `warning`
                    })

                    return
                }

                this.$confirm(`请仔细核对每一条计费成功的项目,审核后页面将会被冻结?`, `提示`, {
                    confirmButtonText: `确定`,
                    cancelButtonText: `取消`,
                    type: `warning`,
                    closeOnClickModal: false
                }).then(() => {
                    let req = this.myaxios.put(`/api/Nursing/Charge/ChangeApprovalStatus?surgeryId=${this.surgeryId}&chargeType=${this.chargeType}&approvalStatus=${approvalStatus}`)
                    req.then(data => {
                        this.loadChargeItems()
                    }).catch(e => {
                        console.log(e)
                    })
                }).catch(e => { })
            } else {
                let req = this.myaxios.put(`/api/Nursing/Charge/ChangeApprovalStatus?surgeryId=${this.surgeryId}&chargeType=${this.chargeType}&approvalStatus=${approvalStatus}`)
                req.then(data => {
                    this.loadChargeItems()
                }).catch(e => {
                    console.log(e)
                })
            }
        },
        loadPermissions() {
            let req = this.myaxios.get(`/api/AcisSystem/Authorization/GetPermissions`) // 获取当前用户的权限
            req.then(data => {
                this.permissions = data
            }).catch(e => {
            })
        },
        setDefaultValue(d) {
            if (!d.enum_pay_type) {
                d.enum_pay_type = this.default_pay_type
            }
            if (!d.doctor || d.doctor == `0`) {
                if ((d.dic_chrg_item_type_id == 7 || (this.setDeptByChrgItemType && this.setDeptByChrgItemType == `2`)) &&
                    this.default_doctor && this.default_doctor.value) {
                    this.$set(d, `doctor`, this.default_doctor)
                } else {
                    this.$set(d, `doctor`, null)
                }
            } else {
                if (_.has(d.doctor, `value`) || _.has(d.doctor, `label`)) {
                    if (!d.doctor.value || !d.doctor.label) {
                        this.$set(d, `doctor`, null)
                    }
                } else {
                    if (d.doctorName && d.doctor) {
                        this.$set(d, `doctor`, {
                            label: d.doctorName,
                            value: d.doctor
                        })
                    } else {
                        this.$set(d, `doctor`, null)
                    }
                }
            }

            if (!d.billing_dept || d.billing_dept == `0`) {
                if (this.setDeptByChrgItemType && this.setDeptByChrgItemType == `1`) {
                    if (d.dic_chrg_item_type_id == 7) { // 如果是手术取临床科室
                        this.$set(d, `billing_dept`, this.default_section) // 临床科室
                    } else { // 其它取手术计费默认科室
                        this.$set(d, `billing_dept`, this.default_oper_section) // 手术计费默认科室
                    }
                } else if (this.setDeptByChrgItemType && this.setDeptByChrgItemType == `2`) {
                    this.$set(d, `billing_dept`, this.default_section) // 临床科室
                } else {
                    this.$set(d, `billing_dept`, this.default_oper_section) // 手术计费默认科室
                }
            }

            if (!d.execute_dept || d.execute_dept == `0`) {
                if (d.dic_chrg_item_type_id == 1 || d.is_drug_type) {
                    this.$set(d, `execute_dept`, this.default_drug_section)// 默认药房
                } else {
                    this.$set(d, `execute_dept`, this.default_oper_section)// 手术计费默认科室
                }
            }
        },
        getSectionNameById(id) {
            if (!id) return ``
            let item = _.find(this.sectionFidlerHospitalWard, x => x.value == parseInt(id))
            if (item) { return item.label || `` }
            return ``
        },
        getSectionById(id) {
            if (!id) return
            let item = _.find(this.sectionFidlerHospitalWard, x => x.value == parseInt(id))
            return item
        },
        select(row) {
            if (this.isMainOperation(row)) {
                if (row.checked) {
                    if (row.children) {
                        row.children.forEach(ch => {
                            ch.disabled = true
                            if (!ch.enum_fee_type || ch.enum_fee_type == 1) {
                                this.$refs.custtb.selectOne(ch, true)
                            } else {
                                this.$refs.custtb.selectOne(ch, false)
                            }
                        })
                    }
                    let allrows = this.$refs.custtb.getAllRows()
                    let addtionRows = _.filter(allrows, x => this.isMainAddition(x))
                    addtionRows.forEach(ad => {
                        if (ad.enum_fee_type == 1) {
                            this.$refs.custtb.selectOne(ad, true)
                            ad.disabled = true
                        }
                    })
                } else {
                    if (row.children) {
                        row.children.forEach(ch => {
                            if (!ch.enum_fee_type || ch.enum_fee_type == 1) {
                                this.$refs.custtb.selectOne(ch, false)
                                ch.disabled = false
                            } else {
                                this.$refs.custtb.selectOne(ch, false)
                                ch.disabled = true
                            }
                        })
                    }
                    let allrows = this.$refs.custtb.getAllRows()
                    let mainCheckedRows = _.filter(allrows, x => this.isMainOperation(x) && x.checked)
                    if (!mainCheckedRows || mainCheckedRows.length == 0) {
                        let addtionRows = _.filter(allrows, x => this.isMainAddition(x))
                        addtionRows.forEach(ad => {
                            if (ad.enum_fee_type == 1) {
                                this.$refs.custtb.selectOne(ad, false)
                                ad.disabled = false
                            } else {
                                this.$refs.custtb.selectOne(ad, false)
                                ad.disabled = true
                            }
                        })
                    }
                }
            } else {

            }
        },
        selectTempItems(row) {
            if (row.checked) {
                if (!row.parentid_guid) {
                    row.children.forEach(ch => {
                        this.$refs.tempItemsTree.selectOne(ch, true)
                    })
                } else {
                    // 父级勾选
                    let allrows = this.$refs.tempItemsTree.getAllData()
                    let parRow = _.filter(allrows, x => x.id_guid == row.parentid_guid)
                    if (parRow && parRow.length > 0) {
                        this.$refs.tempItemsTree.selectOne(parRow[0], true)
                    }
                }
            } else {
                if (!row.parentid_guid) {
                    row.children.forEach(ch => {
                        this.$refs.tempItemsTree.selectOne(ch, false)
                    })
                }
            }
        },
        selectAll(isSelect) {
            var allrows = this.$refs.custtb.getAllRows()
            if (isSelect) {
                allrows.forEach(row => {
                    if (row.id < 0 && (!row.chrg_item || !row.chrg_item.value)) {
                        this.$refs.custtb.selectOne(row, false)
                    } else if (row.enum_fee_type && row.enum_fee_type != 1) {
                        row.disabled = true
                        this.$refs.custtb.selectOne(row, false)
                    } else if (this.isMainAddition(row)) {
                        row.disabled = true
                    }
                    if (row.children) {
                        row.children.forEach(ch => {
                            ch.disabled = true
                            if (row.enum_fee_type && ch.enum_fee_type != 1) {
                                this.$refs.custtb.selectOne(ch, false)
                            }
                        })
                    }
                })
            } else {
                allrows.forEach(row => {
                    row.disabled = row.enum_fee_type && row.enum_fee_type != 1
                    if (row.children) {
                        row.children.forEach(ch => {
                            ch.disabled = ch.enum_fee_type && ch.enum_fee_type != 1
                        })
                    }
                })
            }
        },
        submit() {
            if (_.trim(this.confirmer.data.uid) == ``) {
                this.$message.error(`请输入用户名`)
                this.$refs.uid.focus()
                return
            }

            let user = Object.assign({}, this.confirmer.data)
            if (this.$root.PwdEncryptEnabled && this.$root.PwdEncryptEnabled == `1` && this.$root.RsaPublicKeyLogin) {
                let encryptor = new JSEncrypt()
                encryptor.setPublicKey(this.$root.RsaPublicKeyLogin)
                user.pwd = encryptor.encrypt(user.pwd)
            }

            this.myaxios
                .post(`api/AcisSystem/Authorization/GetUser`, {
                    user_agent: `chrome`,
                    timestamp: new Date().getTime(),
                    data: user
                })
                .then(data => this.confirmerConfirm(data))
        },
        confirmerConfirm(data) {
            let that = this
            let data1
            if (this.chargeRefundType == 1) {
                let allrows = this.$refs.custtb.getAllRows()
                data1 = _.filter(allrows, d => (d.id > 0))
            } else {
                let selectRows = that.$refs.custtb.getSelectedRows()
                data1 = _.filter(selectRows, d => (d.id > 0))
            }

            if (data1 && data1.length > 0) {
                let ids = []
                data1.forEach(t => {
                    ids.push(t.id)
                    if (t.children && t.children.length > 0) {
                        t.children.forEach(ch => {
                            if (ch.id && ch.id > 0) {
                                ids.push(ch.id)
                            }
                        })
                    }
                })

                let req = this.myaxios.post(`/api/Nursing/Charge/ConfrimCharge?confirmer=${data && data.dic_worker_name}`, ids)
                req.then(data => {
                    this.$message.success(`确认成功`)
                    this.confirmer.dialogFormVisible = false
                    this.confirmer.data.uid = ``
                    this.confirmer.data.pwd = ``
                    this.loadChargeItems()
                }).catch(e => {
                    console.log(e)
                })
            }
        },
        SaveAsConfirm(row) {
            var postData = {
                surgeryId: this.surgeryId,
                chargetype: this.chargeType,
                group_id: row.group_id,
                templatename: row.name,
                regions: row.region_type == 1
                    ? [{ owner: this.currentUser.username }]
                    : row.dic_ward_ids.map(d => {
                        return {
                            sys_charge_template_id: 0,
                            dic_operating_ward_id: _.startsWith(d, `ow_`) ? d.substr(3) : 0,
                            dic_recovery_ward_id: _.startsWith(d, `rw_`) ? d.substr(3) : 0
                        }
                    })
            }
            this.myaxios.post(
                `/api/AcisSystem/ChargeTemplate/SaveAsChargeTemplate`,
                postData
            ).then(data => {
                this.$message.success(`另存为模板成功`)
                this.saveas.dialogFormVisible = false
            }).catch(e => this.$message.error(e))
        },
        addTotalPriceProp(data) {
            var that = this
            var pField = that.parentField
            Object.defineProperty(data, `total_price`, {
                get: function() {
                    try {
                        // let name = ``
                        // if (this.chrg_item && this.chrg_item.label == `asdf`) {
                        //     console.log(`------addTotalPriceProp----------`)
                        //     name = this.chrg_item.label
                        // }
                        let amount = parseFloat(this.amount) || 0
                        let rate = parseFloat(this.charg_rate)
                        let unitPrice = parseFloat(this.price) || 0
                        let result = 0
                        if (!amount || amount <= 0) return 0
                        // if (name == `骨盆骨折切开复位内固定术`) { console.log(name + ` |rate=` + rate + `|price=` + unitPrice) }
                        if (that.isMainOperation(this)) {
                            // if (name == `骨盆骨折切开复位内固定术`) { console.log(name + ` isMainOperation`) }
                            if (rate) {
                                let tempprice = that.$multiplyMaths.multiply(amount, unitPrice) * (rate * 100) / 100
                                result = tempprice.toNewFixed(that.charge_Total_Decimaldigits)
                            } else {
                                result = that.$multiplyMaths.multiply(amount, unitPrice).toNewFixed(that.charge_Total_Decimaldigits)
                            }
                        } else if (that.isChildAddition(this)) {
                            // if (name == `骨盆骨折切开复位内固定术`) { console.log(name + ` isChildAddition`) }
                            if (!rate) {
                                result = that.$multiplyMaths.multiply(amount, unitPrice).toNewFixed(that.charge_Total_Decimaldigits)
                            } else {
                                let parent = _.find(that.datalist, x => x.id == this[pField])
                                if (parent) {
                                    let tempprice = that.$multiplyMaths.multiply(amount, parent.total_price) * (rate * 100) / 100
                                    result = tempprice.toNewFixed(that.charge_Total_Decimaldigits)
                                } else {
                                    result = 0
                                }
                            }
                        } else if (that.isMainAddition(this)) {
                            if (!rate) {
                                result = that.$multiplyMaths.multiply(amount, unitPrice).toNewFixed(that.charge_Total_Decimaldigits)
                            } else {
                                let tempprice = that.$multiplyMaths.multiply(amount, that.OperationTotalPrice) * (rate * 100) / 100
                                result = tempprice.toNewFixed(that.charge_Total_Decimaldigits)
                            }
                        } else {
                            // if (name == `骨盆骨折切开复位内固定术`) { console.log(name + ` other`) }
                            if (!rate) {
                                result = that.$multiplyMaths.multiply(amount, unitPrice).toNewFixed(that.charge_Total_Decimaldigits)
                            } else {
                                let tempprice = that.$multiplyMaths.multiply(amount, unitPrice) * (rate * 100) / 100
                                result = tempprice.toNewFixed(that.charge_Total_Decimaldigits)
                            }
                        }
                        if (isNaN(result)) { return 0 }
                        return result
                    } catch (e) {
                        console.log(e)
                    }
                }
            })
        },
        isParent(data) {
            return !data[this.parentField] || data[this.parentField] == 0
        },
        // 获取上一行执行科室、计费科室、执行人设置给当前行对应字段
        setPredataDefault(row, predata) {
            if (!row.doctor) {
                this.$set(row, `doctor`, predata.doctor)
            }
            if (!row.billing_dept) {
                this.$set(row, `billing_dept`, predata.billing_dept)
            }
            if (!row.execute_dept || row.execute_dept == `0`) {
                if (this.defaultPrevRow != `1`) {
                    this.$set(row, `execute_dept`, predata.execute_dept)
                } else {
                    if (row.dic_chrg_item_type_id == 1 || row.is_drug_type) {
                        this.$set(row, `execute_dept`, this.default_drug_section)// 默认药房
                    } else {
                        this.$set(row, `execute_dept`, this.default_oper_section)// 手术计费默认科室
                    }
                }
            }
        },
        isMainOperation(data) {
            return this.isParent(data) &&
                   data.level == 1 &&
                   data.dic_chrg_item_type_id == 7
        },
        isMainAddition(data) {
            let r = this.isParent(data) &&
                    data.level == 2 &&
                    data.dic_chrg_item_type_id == 7
            return r
        },
        isChildAddition(data) {
            return !this.isParent(data) &&
                   data.level == 2 &&
                   data.dic_chrg_item_type_id == 7
        },
        loadChargeItemTypes() {
            return new Promise((resolve, reject) => {
                this.myaxios.get(`/api/AcisSystem/ChargeItem/SearchType`)
                    .then(data => {
                        this.charge_item_types = data
                        resolve(this.charge_item_types)
                    })
            })
        },
        loadAdditionalTypes() {
            return new Promise((resolve, reject) => {
                this.myaxios.get(`/api/AcisSystem/AdditionalType/Get`)
                    .then(data => {
                        this.additional_types = data
                        resolve(this.additional_types)
                    })
            })
        },
        getChargeItemTypeName(id) {
            let item = _.find(this.charge_item_types, x => x.value == id)
            if (item) { return item.label || `` }
            return ``
        },
        ExtraButtonClick({ emit, row, index }) {
            if (row.toId) {
                let parentRow = this.$refs.custtb.getRow(row.toId)
                this.addChild(parentRow)
            } else if (emit == `removeItem`) {
                this.removeItem(row)
            }
        },
        rowClick(row, column, event) {
            if (!column) return
            if (column.label == `操作` || column.type == `selection` || row.rowStatus > 0) {
                return
            }
            if (event.offsetX < 20 && column.label == `项目名称`) {
                return
            }
            if (row.id && ((row.enum_charge_status != 0 && row.enum_charge_status != 2) || row.enum_fee_type != 1)) {
                return
            }
            row.rowStatus = 2
        },
        addChild(row) {
            let ch = this.$refs.custtb.addChild(row)
            if (ch) {
                this.addTotalPriceProp(ch)
            }
        },
        addParent() {
            let pa = this.$refs.custtb.addParent()
            if (pa) {
                this.addTotalPriceProp(pa)
            }
        },
        removeItem(row) {
            let that = this
            let batchdel = (that.permissions && that.permissions.findIndex(item => item.permission === `charge:batchdeletessjf`) !== -1)
            let selectRows = that.$refs.custtb.getSelectedRows()
            if (batchdel && selectRows && selectRows.length > 1) { // 有批量删除权限,且选中了多行
                let ids = []
                try {
                    selectRows.forEach(t => {
                        if (!_.has(t, `chrg_item`) || !t.chrg_item || !t.chrg_item.value) {
                            if (that.$refs.custtb.deleteRow(t) != true) {
                                that.loadChargeItems()
                            }
                            throw new Error(`ending`)
                        }
                        ids.push(t.id)
                        if (t.children && t.children.length > 0) {
                            t.children.forEach(ch => {
                                if (ch.id && ch.id > 0) {
                                    ids.push(ch.id)
                                }
                            })
                        }
                    })
                    this.$confirm(`检测到选择了多条数据，是否全部删除?`, `提示`, {
                        confirmButtonText: `确定`,
                        cancelButtonText: `取消`,
                        type: `warning`,
                        closeOnClickModal: false
                    }).then(() => {
                        let req = this.myaxios.post(`/api/Nursing/Charge/BatchDelete`, ids)
                        req.then(data => {
                            that.loadChargeItems()
                        }).catch(e => {
                            // this.$message.error(`删除异常,请尝试刷新后重新删除`)
                            console.log(e)
                        })
                    }).catch(e => { })
                } catch (e) {
                    ids = []
                    console.log(e.message)
                }
            } else { // 原删除逻辑不动 按照点击行删除数据
                if (!_.has(row, `chrg_item`) || !row.chrg_item || !row.chrg_item.value) {
                    if (that.$refs.custtb.deleteRow(row) != true) {
                        that.loadChargeItems()
                    }
                    return
                }
                this.$confirm(`是否确认删除?`, `提示`, {
                    confirmButtonText: `确定`,
                    cancelButtonText: `取消`,
                    type: `error`
                }).then(() => {
                    if (row.rowStatus == 1) {
                        if (that.$refs.custtb.deleteRow(row) != true) {
                            that.loadChargeItems()
                        }
                    } else {
                        var reqList = []
                        var req = this.myaxios.delete(`/api/Nursing/Charge/Delete/${row.id}`)
                        reqList.push(req)
                        if (row.children && row.children.length > 0) {
                            row.children.forEach(ch => {
                                if (ch.id && ch.id > 0) {
                                    var tmpReq = this.myaxios.delete(`/api/Nursing/Charge/Delete/${ch.id}`)
                                    reqList.push(tmpReq)
                                }
                            })
                        }
                        this.myaxios.all(reqList).then(() => {
                            if (that.$refs.custtb.deleteRow(row) != true) {
                                that.loadChargeItems()
                            }
                        }).catch(e => {
                            this.$message.error(`删除异常,请尝试刷新后重新删除`)
                            console.log(e)
                        })
                    }
                }).catch(() => {})
            }
        },
        handleNodeClick(node, self, child) {
            let that = this
            if (!_.has(node, `children`)) {
                // 加载已选模板详情
                if (!node.value) return
                let req = that.myaxios.get(`/api/AcisSystem/ChargeTemplate/Get/${node.value}`)
                req.then(template => {
                    let r = _.map(template.items, d => {
                        d.enum_fee_type = 1
                        d.enum_charge_status = 0
                        d.total_price = 1.0 * d.charge_item.price
                        d.spec = d.charge_item.spec
                        d.firm = d.charge_item.firm
                        d.sell_unit = d.charge_item.sell_unit
                        d.price = d.charge_item.price
                        d.dic_chrg_item_type_id = d.charge_item && d.charge_item.dic_chrg_item_type_id
                        d.is_drug_type = d.charge_item && d.charge_item.is_drug_type
                        d.dic_chrg_item_type = d.charge_item && this.getChargeItemTypeName(d.charge_item.dic_chrg_item_type_id)
                        d.dic_chrg_item_name = d.charge_item.name
                        d.chrg_item = {
                            label: d.charge_item.name,
                            value: d.charge_item.id
                        }
                        d.rowStatus = 1
                        d.dic_section_id = d.dic_section_id
                        if (d.dic_section_id && d.dic_section_id > 0) {
                            d.execute_dept = this.getSectionById(d.dic_section_id)
                        }

                        d.id_guid = d.id_guid
                        d.parentid_guid = d.parentid_guid
                        d.level = d.charge_item.level
                        return d
                    })
                    let datalist = _.orderBy(r, `display_order`)
                    that.collectCharges.datalist = this.$refs.tempItemsTree.toTree(datalist)
                    this.$nextTick(function() {
                        if (this.charge_template_selected && this.charge_template_selected === `1`) {
                            this.$refs.tempItemsTree.selectAll(true)
                        }
                    })
                })
            }
        },
        loadSurgery() {
            return new Promise((resolve, reject) => {
                if (!this.surgeryId) {
                    resolve()
                    return
                }
                if (this.surgeryInfo && this.surgeryInfo.id == this.surgeryId) {
                    resolve(this.surgeryInfo)
                } else {
                    resolve(this.loadSurgerybody())
                }
            })
        },
        loadSurgerybody() {
            return new Promise((resolve, reject) => {
                let req1 = this.myaxios.get(`/api/Preoperative/Apply/Get/${this.surgeryId}`)
                req1.then(data => {
                    this.surgeryInfo = data
                    this.expeditedStatus = data.is_expedited
                    this.default_pay_type = this.surgeryInfo.visit_info && this.surgeryInfo.visit_info.enum_pay_type
                    if (this.configdefaultPayType != `0`) {
                        this.default_pay_type = this.configdefaultPayType
                    }
                    this.default_oper_section_id = this.surgeryInfo.oper_section_id
                    if (this.surgeryInfo.oper_section_id && this.surgeryInfo.oper_section_id > 0) {
                        this.default_oper_section = this.getSectionById(this.surgeryInfo.oper_section_id)
                    }

                    this.default_drug_section_id = this.surgeryInfo.drug_oper_section_id
                    if (this.surgeryInfo.drug_oper_section_id && this.surgeryInfo.drug_oper_section_id > 0) {
                        this.default_drug_section = this.getSectionById(this.surgeryInfo.drug_oper_section_id)
                    }

                    this.default_section_id = this.surgeryInfo.dic_section_id
                    if (this.surgeryInfo.dic_section_id && this.surgeryInfo.dic_section_id > 0) {
                        this.default_section = this.getSectionById(this.surgeryInfo.dic_section_id)
                    }

                    if (this.surgeryInfo.fact_surgeon && this.surgeryInfo.fact_surgeon.value) {
                        this.default_doctor = {
                            label: this.surgeryInfo.fact_surgeon.label,
                            value: this.surgeryInfo.fact_surgeon.value
                        }
                    } else if (this.surgeryInfo.plan_surgeon && this.surgeryInfo.plan_surgeon.value) {
                        this.default_doctor = {
                            label: this.surgeryInfo.plan_surgeon.label,
                            value: this.surgeryInfo.plan_surgeon.value
                        }
                    }
                    resolve(this.surgeryInfo)
                }).catch(e => {
                    console.log(e)
                    resolve({})
                })
            })
        },
        filterCondition(d) {
            return (this.charge_item_type.length == 0 || (this.charge_item_type && this.charge_item_type == d.dic_chrg_item.dic_chrg_item_type_id)) &&
                        (d.enum_charge_status == this.status || this.status.length == 0) &&
                        (d.enum_fee_type == this.fee_type || this.fee_type.length == 0)
        },
        refreshChargeItems() {
            this.loadChargeItems(`refresh`)
            this.$emit(`refreshsurgeInfos`)
        },
        loadChargeItems(refresh) {
            return new Promise((resolve, reject) => {
                if (!this.surgeryId) {
                    resolve()
                    return
                }
                if (refresh == `refresh`) {
                    this.loadSurgery().then(() => {
                        this.loadChargeItemsAsync()
                    })
                } else {
                    this.loadChargeItemsAsync()
                }

                resolve()
            })
        },
        loadChargeItemsAsync() {
            if (!this.surgeryId) return
            let that = this
            this.myaxios.get(`/api/Nursing/Charge/Get?surgeryId=${this.surgeryId}&&chargeType=${this.chargeType}`)
                .then(data => {
                    let olddatalist = this.datalist.concat()
                    console.log(data)
                    let hasapprovaled = data && _.filter(data, d => d.approval_status == 1)
                    if (hasapprovaled.length > 0) {
                        // 有审核的，则冻结页面
                        this.approvalStatus = true
                    } else {
                        this.approvalStatus = false
                    }

                    var searchResult = []
                    data.forEach(d => {
                        let tmpResult = this.filterCondition(d)
                        if (tmpResult == true) {
                            searchResult.push(d)
                        } else if (this.isParent(d)) {
                            let ch = _.filter(data, x => x[this.parentField] == d.id && this.filterCondition(x))
                            if (ch && ch.length > 0) {
                                searchResult.push(d)
                            }
                        }
                    })
                    let mainOperationRows = []
                    let mainAdditionRows = []
                    let childRows = []
                    let bjfRows = [] // 不计费数组
                    let otherRows = []
                    let tmp = _.map(searchResult, (d, index) => {
                        d.font_color = d.dic_chrg_item && d.dic_chrg_item.font_color
                        d.chrg_item_type_abbr = d.dic_chrg_item && d.dic_chrg_item.chrg_item_type_abbr

                        d.class_name = that.getRowClassName(d)

                        d.spec = d.spec || ((d.dic_chrg_item && d.dic_chrg_item.spec) || ``)
                        d.sell_unit = d.sell_unit || ((d.dic_chrg_item && d.dic_chrg_item.sell_unit) || ``)
                        d.price = d.price || ((d.dic_chrg_item && d.dic_chrg_item.price) || ``)
                        d.dic_chrg_item_type = d.dic_chrg_item_type || ((d.dic_chrg_item && d.dic_chrg_item.dic_chrg_item_type) || ``)
                        d.dic_chrg_item_type_id = d.dic_chrg_item_type_id || ((d.dic_chrg_item && d.dic_chrg_item.dic_chrg_item_type_id) || ``)
                        d.is_drug_type = d.dic_chrg_item && d.dic_chrg_item.is_drug_type
                        d.dic_chrg_item_name = d.dic_chrg_item_name || ((d.dic_chrg_item && d.dic_chrg_item.name) || ``)
                        d.chrg_item = {
                            label: d.item_name || ((d.dic_chrg_item && d.dic_chrg_item.name) || ``),
                            value: d.dic_chrg_item_id || ((d.dic_chrg_item && d.dic_chrg_item.id) || 0)
                        }
                        if (d.billing_dept && d.billing_dept != `0`) {
                            d.billing_dept = that.getSectionById(d.billing_dept)
                        }

                        if (d.execute_dept && d.execute_dept != `0`) {
                            d.execute_dept = that.getSectionById(d.execute_dept)
                        }
                        d.limit_price_type = d.dic_chrg_item && d.dic_chrg_item.limit_price_type
                        d.min_price = d.dic_chrg_item && d.dic_chrg_item.min_price
                        d.max_price = d.dic_chrg_item && d.dic_chrg_item.max_price
                        d.uni_charge_code = (d.dic_chrg_item && d.dic_chrg_item.uni_charge_code) || ``
                        this.setDefaultValue(d)

                        d.disabled = d.enum_fee_type != 1
                        this.addTotalPriceProp(d)
                        if (this.isMainOperation(d)) {
                            mainOperationRows.push(d)
                        } else if (this.isMainAddition(d)) {
                            mainAdditionRows.push(d)
                        } else if (this.isChildAddition(d)) {
                            childRows.push(d)
                        } else if (d.dic_chrg_item_type == `不计费`) {
                            bjfRows.push(d)
                        } else {
                            otherRows.push(d)
                        }
                        return d
                    })

                    tmp = mainOperationRows.concat(mainAdditionRows, childRows, otherRows, bjfRows)
                    if (this.$refs.custtb) {
                        let treeData = this.$refs.custtb.toTree(tmp)
                        let newData = []
                        treeData.forEach(tr => {
                            newData.push(tr)
                            if (this.isMainOperation(tr) && tr.enum_charge_status == 0 && this.chargeItemAddConfig == `1`) {
                                let newRow = this.$refs.custtb.newRow(0)
                                newRow.readonly = true
                                newRow.html = `<div style="color:#009697;cursor:pointer;width:100px">+ 添加子加收</div>`
                                newRow.toId = tr.id
                                newRow.disabled = true
                                newData.push(newRow)
                            }
                        })
                        let pa = this.$refs.custtb && this.$refs.custtb.newRow(1)
                        // pa.class_name = ` charge-row`
                        if (pa && this.chargeItemAddConfig == `1`) {
                            this.addTotalPriceProp(pa)
                            newData.push(pa)
                        }
                        this.datalist = newData
                    } else {
                        this.$nextTick(() => {
                            let treeData = this.$refs.custtb && this.$refs.custtb.toTree(tmp)
                            let newData = []
                            if (treeData && treeData.length > 0) {
                                treeData.forEach(tr => {
                                    newData.push(tr)
                                    if (this.isMainOperation(tr) && tr.enum_charge_status == 0 && this.chargeItemAddConfig == `1`) {
                                        let newRow = this.$refs.custtb.newRow(0)
                                        newRow.readonly = true
                                        newRow.html = `<div style="color:#009697;cursor:pointer;width:100px">+ 添加子加收</div>`
                                        newRow.toId = tr.id
                                        newRow.disabled = true
                                        newData.push(newRow)
                                    }
                                })
                            }
                            let pa = this.$refs.custtb && this.$refs.custtb.newRow(1)
                            if (pa && this.chargeItemAddConfig == `1`) {
                            // pa.class_name = ` charge-row`
                                this.addTotalPriceProp(pa)
                                newData.push(pa)
                            }
                            this.datalist = newData
                            console.log(`loadChargeItemsAsync`, newData)
                        })
                    }

                    if (this.isDrugAlert && (this.syncUseDrugIn || this.templateIn)) { // 开启特殊用药弹框提示 且 点击了同步用药或者提取模板
                        for (const r of this.datalist) {
                            if (r.dic_chrg_item && r.dic_chrg_item != null) {
                                // 计费项类型是药品 且 药品Remark有值【remark有值表示特殊用药】
                                if (r.dic_chrg_item.remark && (this.isDrugChargeItemShow == `1` || (this.isDrugChargeItemShow == `2` && (r.dic_chrg_item.is_special_medication || 0) == 1))) {
                                    let noexist = _.find(olddatalist, function(m) {
                                        return m.id == r.id
                                    })
                                    if (!noexist) {
                                        this.$confirm(`医保中心提示：该项目 【${r.chrg_item.label}】 <br/><br/>${r.dic_chrg_item.remark}<br/><br/>选择【是】将设置为医保，【否】将设置为自费，【X】不开立本医嘱`, `医保中心提示`, {
                                            confirmButtonText: `是`,
                                            cancelButtonText: `否`,
                                            distinguishCancelAndClose: true,
                                            dangerouslyUseHTMLString: true,
                                            closeOnClickModal: false
                                        }).then(() => {
                                            r.enum_pay_type = 2 // 是 2=医保
                                        }).catch((action) => {
                                            if (action === `cancel`) {
                                                r.enum_pay_type = 3 // 否 3=自费
                                            } else { // 取消同步
                                                let idx = _.findIndex(this.datalist, { id: r.id })
                                                if (idx >= 0) {
                                                    this.removeItem(r)
                                                }
                                            }
                                        })
                                    }
                                }
                            }
                        }
                        this.syncUseDrugIn = false
                        this.templateIn = false // 弹框结束后，设置成false
                    }
                })
        },
        saveItems(his) {
            let that = this

            return new Promise((resolve, reject) => {
                try {
                    var alldata = this.$refs.custtb.getAllData()
                    var savedata = _.filter(alldata, d => d.chrg_item && d.chrg_item.value)
                    var nonePayTypeArr = []
                    var noneAmountArr = []
                    var noneRateOrPriceArr = []
                    savedata.forEach(d => {
                        if (d.enum_pay_type == null || !d.execute_dept || (d.execute_dept && !d.execute_dept.value) || !d.billing_dept || (d.billing_dept && !d.billing_dept.value) || !d.doctor || (d.doctor && !d.doctor.value)) {
                            nonePayTypeArr.push(d)
                            this.$set(d, `class_name`, `fontred`)
                        } else if (!d.amount || d.amount <= 0) {
                            d.amount = 0
                            noneAmountArr.push(d)
                        } else if (this.isMainOperation(d)) {
                            if (!d.price) {
                                d.price = 0
                                noneRateOrPriceArr.push(d)
                            } else {
                                d.class_name = that.getRowClassName(d)
                            }
                        } else if (this.isChildAddition(d)) {
                            if (!d.price && !d.charg_rate) {
                                d.price = 0
                                noneRateOrPriceArr.push(d)
                            } else {
                                d.class_name = that.getRowClassName(d)
                            }
                        } else if (this.isMainAddition(d)) {
                            if (!d.price && !d.charg_rate) {
                                d.price = 0
                                noneRateOrPriceArr.push(d)
                            } else {
                                d.class_name = that.getRowClassName(d)
                            }
                        } else if (!d.price) {
                            d.price = 0
                            if (d.dic_chrg_item_type != `不计费`) {
                                noneRateOrPriceArr.push(d)
                            }
                        } else {
                            d.class_name = that.getRowClassName(d)
                        }
                    })
                    if (nonePayTypeArr.length > 0) {
                        this.$message.error(`收费类别，开单人，开单科室，执行科室，不能为空`)
                        return
                    }
                    if (noneAmountArr.length > 0 || noneRateOrPriceArr.length > 0) {
                        this.$confirm(`存在计费数量，或（单价，比例）为空的数据<br/>是否确认保存?`, `提示`, {
                            dangerouslyUseHTMLString: true,
                            confirmButtonText: `确定`,
                            cancelButtonText: `取消`,
                            type: `warning`
                        }).then(() => {
                            let data1 = this.getAdd(savedata)
                            let data2 = this.getEdit(savedata)
                            if (data1.length > 0 || data2.length > 0) {
                                // 计费中存在相同计费项目是否提示,欢哥加的弱验证，不阻止提交
                                if (this.$root.IsChargeShowAlertHasSameItem == `1`) {
                                    this.validSameItem(savedata)
                                }
                                // 计费中存在相同计费项目是否提示,肖锐加的强验证，阻止提交
                                if (this.$root.IsChargeShowAlertHasSameItem == `2`) {
                                    try {
                                        this.validSameItem(savedata, true)
                                    } catch (e) {
                                        if (e.message != `EndIterative`) throw e
                                        return
                                    }
                                }

                                let req1 = this.myaxios.post(`/api/Nursing/Charge/Post`, data1)
                                let req2 = this.myaxios.put(`/api/Nursing/Charge/PutMany`, data2)
                                this.myaxios
                                    .all(req1, req2)
                                    .then(([res1, res2]) => {
                                        // 执行保存后逻辑
                                        this.myaxios.post(`/api/Nursing/Charge/SaveAfter?surgeryId=${this.surgeryId}&chargetype=${this.chargeType}`).then(e => {
                                            // 如果这个res有值，证明发送前校验异常，则提示并且刷新页面
                                            if (e && e != ``) {
                                                this.$alert(e, `提醒`, {
                                                    dangerouslyUseHTMLString: true,
                                                    type: `warning`
                                                })
                                            }

                                            if (his == `his`) {
                                                resolve()
                                            } else {
                                                if (res2 && res2 != ``) {
                                                    this.$alert(res2, `提醒`, {
                                                        dangerouslyUseHTMLString: true,
                                                        type: `warning`
                                                    })
                                                }
                                                this.$message.success(`保存成功`)
                                                this.loadChargeItems()

                                                // ACIS-24359收费时判断库存
                                                if (this.$root.IsCheckChargeStock == `1`) {
                                                    let reqStock = this.myaxios.post(
                                                        `/api/Nursing/Charge/CheckStock?surgeryId=${this.surgeryId}&chargeType=${this.chargeType}&sendJfType=${this.sendJfType}`,
                                                        []
                                                    )
                                                    reqStock.then(data => {
                                                        if (data && !data.status) {
                                                            this.$alert(`项目库存不足:<br>` + data.msg, `提示`, {
                                                                dangerouslyUseHTMLString: true,
                                                                type: `warning`
                                                            })
                                                        }
                                                    })
                                                }
                                                resolve()
                                            }
                                        })
                                    })
                                    .catch(e => {
                                        this.loadChargeItems()
                                        reject(e)
                                    })
                            } else {
                                if (his != `his`) {
                                    this.$message.warning(`没有可保存项`)
                                }
                                resolve()
                            }
                        }).catch(e => {
                            if (noneAmountArr.length > 0) {
                                noneAmountArr.forEach(d => {
                                    this.$set(d, `class_name`, `fontred`)
                                })
                            }
                            if (noneRateOrPriceArr.length > 0) {
                                noneRateOrPriceArr.forEach(d => {
                                    this.$set(d, `class_name`, `fontred`)
                                })
                            }
                        })
                    } else {
                        let data1 = this.getAdd(savedata)
                        let data2 = this.getEdit(savedata)
                        if (data1.length > 0 || data2.length > 0) {
                            // 计费中存在相同计费项目是否提示,欢哥加的弱验证，不阻止提交
                            if (this.$root.IsChargeShowAlertHasSameItem == `1`) {
                                this.validSameItem(savedata)
                            }
                            // 计费中存在相同计费项目是否提示,肖锐加的强验证，阻止提交
                            if (this.$root.IsChargeShowAlertHasSameItem == `2`) {
                                try {
                                    this.validSameItem(savedata, true)
                                } catch (e) {
                                    if (e.message != `EndIterative`) throw e
                                    return
                                }
                            }
                            let req1 = this.myaxios.post(`/api/Nursing/Charge/Post`, data1)
                            let req2 = this.myaxios.put(`/api/Nursing/Charge/PutMany`, data2)
                            this.myaxios
                                .all(req1, req2)
                                .then(([res1, res2]) => {
                                    // 执行保存后逻辑
                                    this.myaxios.post(`/api/Nursing/Charge/SaveAfter?surgeryId=${this.surgeryId}&chargetype=${this.chargeType}`).then(e => {
                                        // 如果这个res有值，证明发送前校验异常，则提示并且刷新页面
                                        if (e && e != ``) {
                                            this.$alert(e, `提醒`, {
                                                dangerouslyUseHTMLString: true,
                                                type: `warning`
                                            })
                                        }
                                        if (his == `his`) {
                                            resolve()
                                        } else {
                                            if (res2 && res2 != ``) {
                                                this.$alert(res2, `提醒`, {
                                                    dangerouslyUseHTMLString: true,
                                                    type: `warning`
                                                })
                                            }
                                            this.$message.success(`保存成功`)
                                            this.loadChargeItems()
                                            // ACIS-24359收费时判断库存
                                            if (this.$root.IsCheckChargeStock == `1`) {
                                                let reqStock = this.myaxios.post(
                                                    `/api/Nursing/Charge/CheckStock?surgeryId=${this.surgeryId}&chargeType=${this.chargeType}&sendJfType=${this.sendJfType}`,
                                                    []
                                                )
                                                reqStock.then(data => {
                                                    if (data && !data.status) {
                                                        this.$alert(`项目库存不足:<br>` + data.msg, `提示`, {
                                                            dangerouslyUseHTMLString: true,
                                                            type: `warning`
                                                        })
                                                    }
                                                })
                                            }
                                            resolve()
                                        }
                                    })
                                })
                                .catch(e => {
                                    this.loadChargeItems()
                                    reject(e)
                                })
                        } else {
                            if (his != `his`) {
                                this.$message.warning(`没有可保存项`)
                            }
                            resolve()
                        }
                    }
                } catch (e) {
                    console.log(e)
                    reject(e)
                }
            })
        },
        validSameItem(savedata, force) {
            // 未发送的且类型为计费的，要判断是否项目重复，重复不允许保存
            let alllist = _.filter(savedata, d => d.chrg_item && d.enum_fee_type == 1 && d.enum_charge_status == 0)
            let msg = []
            alllist.forEach(n => {
                let exists = _.filter(savedata, p => p.id != n.id && p.chrg_item.value == n.chrg_item.value &&
                    (p.consumables_batch == n.consumables_batch || (p.consumables_batch == null && n.consumables_batch == ``) || (p.consumables_batch == `` && n.consumables_batch == null)) &&
                    p.enum_fee_type == 1 && p.enum_charge_status == 0)
                if (exists && exists.length > 0) {
                    msg.push(n.chrg_item.label)
                }
            })
            if (msg.length > 0) {
                let unitmsg = _.uniq(msg)
                this.$alert(`项目:${unitmsg.join(`,`)} 重复 请调整！`, `提示`, {
                    dangerouslyUseHTMLString: true,
                    type: `warning`
                })
                if (force) throw new Error(`EndIterative`)
            }
        },
        SyncSurgeryCharge() {
            this.syncUseDrugIn = true
            let req = this.myaxios.post(`/api/Nursing/Charge/SyncSurgeryCharge?surgeryId=${this.surgeryId}&&chargeType=${this.chargeType}`)
            req.then(data => {
                this.loadChargeItems()
            })
        },
        loadTemplates(hospitalwardid) {
            let that = this
            return new Promise((resolve, reject) => {
                let req = that.myaxios.get(`/api/AcisSystem/ChargeTemplate/GetTemplate?hospital_ward_id=${hospitalwardid}`)
                req.then(data => {
                    if (this.permissions && this.permissions.findIndex(item => item.permission === `tmp:area_read`) === -1 &&
                        this.permissions.findIndex(item => item.permission === `tmp:alltmp`) === -1) {
                        data = _.filter(data, x => x.owner == ((this.currentUser && this.currentUser.username) || `--`))
                    }
                    resolve(data)
                }).catch(e => reject(e))
            })
            // })
        },
        loadTemplatesView() {
            // 加载可选模板，弹出模板选择框
            this.collectCharges.selected_template = undefined
            this.collectCharges.datalist = []
            let that = this
            that.loadSurgery().then((surgery) => {
            // 加载可用模板
                let hospitalwardid = 0
                if (that.surgeryInfo && that.surgeryInfo.source_hospital_ward_id) {
                    // 这里是患者应用
                    hospitalwardid = that.surgeryInfo.source_hospital_ward_id
                }
                // else if (that.onlySimpleWard == `1`) {
                //     // 单院区过滤
                //     hospitalwardid = that.active_ward.groupId
                // }
                // 个人的时候不过滤院区
                hospitalwardid = that.region_type == 1 ? 0 : hospitalwardid
                this.loadTemplates(hospitalwardid).then(data => {
                    if (this.hasRegionTypePermission.length == 1) {
                        that.region_type = 2
                    }
                    let newchargeType = this.chargeType || 0
                    if (newchargeType == `0` || newchargeType == `101` || newchargeType == `102` || newchargeType == `103`) {
                        newchargeType = `0`
                    }
                    let isShowLeftTemplateTree = that.charge_template_group.length > 0

                    var searchResult = []
                    var ownerResult = []
                    var wardResult = []
                    data = _.filter(data, d => {
                        return d.enum_charge_type == newchargeType
                    })

                    // 模板关键字过滤
                    if (that.region_searchKey) {
                        data = _.filter(data, x => x.name.indexOf(that.region_searchKey) != -1 || x.abbr.indexOf(that.region_searchKey.toUpperCase()) != -1)
                    }

                    _.forEach(data, g => {
                        let r = { ...g }
                        if (r.owner && r.owner == this.currentUser.username) {
                            ownerResult.push(r)
                        }

                        if (!r.owner) {
                            if (!this.fromDesptop) {
                                r.dic_ward_id = r.dic_operating_ward_id && r.dic_operating_ward_id > 0 ? `ow_${r.dic_operating_ward_id}` : `rw_${r.dic_recovery_ward_id}`
                                r.dic_ward_ids = r.regions && r.regions.map(s => {
                                    return s.dic_operating_ward_id && s.dic_operating_ward_id > 0 ? `ow_${s.dic_operating_ward_id}` : `rw_${s.dic_recovery_ward_id}`
                                }) || []
                                if (hospitalwardid > 0) {
                                    // 有来源院区的直接插入
                                    wardResult.push(r)
                                } else {
                                    let wardids = []
                                    if (_.startsWith(that.active_ward.value, `ow_`)) {
                                        // 获取当前手术室关联的复苏室
                                        wardids = this.getOperWardLinkRecoveryIds(this.active_ward.origion)
                                    } else {
                                    // 获取当前复苏室关联的手术区
                                        wardids = this.getRecoveryOperWardIds(this.active_ward.origion)
                                    }

                                    // 获取属于当前复苏室和复苏室关联手术区的模板或者 当前手术区和手术区关联复苏室的模板
                                    let cnt = _.intersection(r.dic_ward_ids, wardids).length
                                    if (r.dic_ward_id == this.active_ward.value || cnt > 0) {
                                        wardResult.push(r)
                                    }
                                }
                            } else {
                                if (hospitalwardid > 0) {
                                    // 有来源院区的直接插入
                                    wardResult.push(r)
                                } else {
                                // 从桌面端麻醉单上tab页签进入，根据麻醉单还是复苏单，麻醉单直接拿当前手术区的模板
                                    let currentSurWardId = this.record_type == 2 ? surgery.dic_recovery_ward_id : surgery.dic_operating_ward_id
                                    let currentTempWardId = this.record_type == 2 ? r.dic_recovery_ward_id : r.dic_operating_ward_id
                                    if (currentSurWardId == currentTempWardId) {
                                        wardResult.push(r)
                                    }
                                }
                            }
                        }
                    }
                    )

                    let ts = []
                    if (isShowLeftTemplateTree) {
                        searchResult = that.region_type == 1 ? searchResult.concat(ownerResult) : searchResult.concat(wardResult)
                        let groupId = _.groupBy(searchResult, `id`)
                        ts = _.reduce(
                            groupId,
                            function(result, g, key) {
                                // 判断模板是不是复苏室模板，是复苏室模板背景色标识一下
                                let isRecoveryTemplate = false
                                if (that.region_type == 2) {
                                    var rwTemplates = _.filter(g[0].dic_ward_ids, d => _.startsWith(d, `rw_`))
                                    isRecoveryTemplate = rwTemplates && rwTemplates.length > 0
                                }
                                let r = {
                                    label: g[0].name,
                                    value: g[0].id,
                                    jianpin: g[0].abbr,
                                    code: g[0].abbr,
                                    group_id: g[0].group_id || 0,
                                    is_recovery_template: isRecoveryTemplate,
                                    display_order: g[0].display_order
                                }
                                result.push(r)
                                return result
                            },
                            []
                        )
                        let templategroups = [...that.charge_template_group]
                        templategroups.push({ value: 0, label: `其它`, children: [] })
                        let templateTree = templategroups.map(s => {
                            var pddata = _.filter(ts, d => d.group_id == parseInt(s.value))
                            s.children = _.orderBy(pddata, `display_order`)
                            return s
                        })
                        templateTree = _.filter(templateTree, x => x.children.length > 0)
                        that.templateTree.data = templateTree
                    } else {
                        searchResult = searchResult.concat(ownerResult)
                        searchResult = searchResult.concat(wardResult)
                        let groupId = _.groupBy(searchResult, `id`)
                        ts = _.reduce(
                            groupId,
                            function(result, g, key) {
                                let region = g.map(s => {
                                    let ow = s.dic_operating_ward_id && _.find(that.ward_auth, { value: `ow_${s.dic_operating_ward_id}` })
                                    let rw = s.dic_recovery_ward_id && _.find(that.ward_auth, { value: `rw_${s.dic_recovery_ward_id}` })
                                    return (ow && ow.label) || (rw && rw.label) || that.currentUser.dic_worker_name
                                })

                                let r = {
                                    label: g[0].name,
                                    value: g[0].id,
                                    jianpin: g[0].abbr,
                                    code: region.join(`,`),
                                    group: _.includes(region, that.currentUser.dic_worker_name) ? `个人模板` : `区域模板`
                                }
                                result.push(r)
                                return result
                            },
                            []
                        )
                    }

                    this.collectCharges.charge_template = _.orderBy(ts, `group`)
                    this.collectCharges.dialogFormVisible = true
                })
            })
        },
        addTemplateToList() {
            let selectedTempItems = this.$refs.tempItemsTree.getSelectedRows()
            this.templateIn = true
            if (selectedTempItems && selectedTempItems.length > 0) {
                let data1 = _.map(selectedTempItems, d => {
                    return {
                        biz_surgery_info_id: this.surgeryId,
                        enum_charge_type: this.chargeType,
                        enum_fee_type: d.enum_fee_type,
                        enum_charge_status: d.enum_charge_status,
                        enum_pay_type: d.enum_pay_type,
                        dic_chrg_item_id: d.chrg_item.value,
                        amount: d.amount,
                        price: d.price,
                        execute_dept: d.dic_section_id && d.dic_section_id > 0 ? d.dic_section_id : null,
                        doctor: d.doctor,
                        additional_type: d.additional_type,
                        item_name: d.chrg_item.label,
                        charg_rate: d.charg_rate,
                        total_price: d.total_price,
                        id_guid: d.id_guid,
                        parentid_guid: d.parentid_guid,
                        level: d.level,
                        display_order: d.display_order,
                        sys_charge_template_id: d.sys_charge_template_id,
                        special_medication_remark: d.charge_item && d.charge_item.remark || `` // 27186 ，有特殊用药
                    }
                })
                let req1 = this.myaxios.post(`/api/Nursing/Charge/AddTemplateToList`, data1)
                req1.then((data) => {
                    if (data && data.length > 0 && data[0].notifymessage) {
                        let notify = data[0].notifymessage
                        this.$alert(notify, `提醒`, {
                            dangerouslyUseHTMLString: true,
                            type: `warning`
                        })
                    }
                    this.collectCharges.dialogFormVisible = false
                    this.loadChargeItems()
                })
            } else {
                this.$message.warning(`未选择计费项`)
                return false
            }
        },
        // 获取复苏室关联的手术区
        getRecoveryOperWardIds(recoveryid) {
            let that = this
            let r = _.find(that.recovery_ward_all, { id: recoveryid })
            return (r && r.dic_operating_ward_ids && r.dic_operating_ward_ids.map(d => {
                return `ow_${d}`
            })) || []
        },
        // 获取手术区关联的复苏区
        getOperWardLinkRecoveryIds(operatingid) {
            let that = this
            let linkRecoveryIds = []
            for (var i = 0; i < that.recovery_ward_all.length; i++) {
                let cur = that.recovery_ward_all[i]
                if (cur.dic_operating_ward_ids && _.includes(cur.dic_operating_ward_ids, operatingid)) {
                    linkRecoveryIds.push(`rw_${cur.id}`)
                }
            }
            return linkRecoveryIds
        },
        sendHis() {
            // 1,alldata页面所有数据
            var alldata = this.$refs.custtb.getAllData()
            // 2,savedata页面所有有效数据（有计费项）
            var savedata = _.filter(alldata, d => d.chrg_item && d.chrg_item.value)
            // 3,执行保存逻辑
            this.saveItems(`his`)
                .then(() => {
                    // 保存后判断计费发送类型，如果为1则全部发送，else勾选发送
                    if (this.sendJfType == `1`) {
                        // 全部发送直接取页面所有有效数据，判断页面是否有有效数据
                        if (!savedata || savedata.length == 0) {
                            this.$message.warning(`没有可以发送的数据`)
                            this.loadChargeItems()
                            return
                        }
                        this.$confirm(`是否确认发送?`, `发送操作`, {
                            confirmButtonText: `确定`,
                            cancelButtonText: `取消`,
                            closeOnClickModal: false
                        }).then(() => {
                            // 确认发送后，后端直接获取所有该发送的数据，进行发送
                            let req = this.myaxios.post(
                                `/api/Nursing/Charge/SubmitJF?surgeryId=${this.surgeryId}&chargeType=${this.chargeType}&sendJfType=${this.sendJfType}`,
                                []
                            )
                            req.then((res) => {
                                // 如果这个res有值，证明发送前校验异常，则提示并且刷新页面
                                if (res && res != ``) {
                                    this.$alert(res, `提醒`, {
                                        dangerouslyUseHTMLString: true,
                                        type: `warning`
                                    }).then(data => {
                                        this.loadChargeItems()
                                    }).catch(this.loadChargeItems())
                                    return
                                }
                                // 提示已发送，并且刷新页面
                                this.$message.success(`已发送`)
                                this.loadChargeItems()
                            })
                        }).catch(() => {})
                    } else {
                        // 勾选发送取页面勾选有效数据进行发送
                        // 这里增加一个判断逻辑。保存后如果有新增的数据，则提示客户让他重新勾选,并且刷新页面（保存后页面未刷新id未生成场景导致异常）
                        let dataadd = this.getAdd(savedata)
                        console.log(dataadd)
                        if (dataadd && dataadd.length > 0) {
                            this.$alert(`您有未保存的数据，已为您执行保存，请重新勾选发送`, `提醒`, {
                                dangerouslyUseHTMLString: true,
                                type: `warning`
                            }).then(data => {
                                this.loadChargeItems()
                            }).catch(this.loadChargeItems())
                            return
                        }

                        // 获取选中数据
                        let selectRows = this.$refs.custtb.getSelectedRows()
                        // 过滤选中数据
                        let data1 = _.filter(selectRows, d => (d.enum_charge_status == 0 || d.enum_charge_status == 2) && d.enum_fee_type == 1) // 收费+待审核
                        // 过滤后校验选中数据
                        if (!data1 || data1.length == 0) {
                            this.$message.warning(`没有可以发送的数据`)
                            this.loadChargeItems()
                            return
                        }
                        this.$confirm(`是否确认发送?`, `发送操作`, {
                            confirmButtonText: `确定`,
                            cancelButtonText: `取消`,
                            closeOnClickModal: false
                        }).then(() => {
                            let req = this.myaxios.post(
                                `/api/Nursing/Charge/SubmitJF?surgeryId=${this.surgeryId}&chargeType=${this.chargeType}&sendJfType=${this.sendJfType}`,
                                _.map(data1, d => d.id)
                            )
                            req.then((res) => {
                                // 如果这个res有值，证明发送前校验异常，则提示并且刷新页面
                                if (res && res != ``) {
                                    this.$alert(res, `提醒`, {
                                        dangerouslyUseHTMLString: true,
                                        type: `warning`
                                    }).then(data => {
                                        this.loadChargeItems()
                                    }).catch(this.loadChargeItems())
                                    return
                                }
                                // 提示已发送，并且刷新页面
                                this.$message.success(`已发送`)
                                this.loadChargeItems()
                            })
                        }).catch(() => {})
                    }
                })
                .catch(e => {
                    console.log(e)
                })
        },
        printChargeItems() {
            let docId = this.$root.DOCUMENT[`SSJF002`]
            console.log(docId)
            this.saveItems().then(() => {
                let req2 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=isShowSendPrintMessage`)
                req2.then(isShow => {
                    this.$store.dispatch(`PRINT_PDF`, {
                        host: this.$root.DOCSERVICE_BASE,
                        params: Object.assign(
                            {
                                docid: docId,
                                chargeType: this.chargeType,
                                id1: this.surgeryId
                            },
                            { isShowSendPrintMessage: isShow.value }
                        )
                    })
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        printChargeAllItems() {
            let docId = this.$root.DOCUMENT[`SSJF001`]
            console.log(docId)
            this.saveItems().then(() => {
                let req2 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=isShowSendPrintMessage`)
                req2.then(isShow => {
                    this.$store.dispatch(`PRINT_PDF`, {
                        host: this.$root.DOCSERVICE_BASE,
                        params: Object.assign(
                            {
                                docid: docId,
                                chargeType: this.chargeType,
                                id1: this.surgeryId
                            },
                            { isShowSendPrintMessage: isShow.value }
                        )
                    })
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        SaveAsTemplate() {
            let alldata = this.$refs.custtb.getAllData()
            let tmpldatalist = _.filter(alldata, x => x.chrg_item && x.chrg_item.value && x.enum_fee_type == 1)
            if (!tmpldatalist || tmpldatalist.length == 0) {
                this.$message.warning(`没有可以存为模板的计费项，可请刷新后重试`)
                return
            }
            this.saveas.dialogFormVisible = true
        },
        withdrawHis() {
            if (this.chargeRefundType == 1) {
                this.$confirm(`是否确认撤销?`, `撤销操作`, {
                    confirmButtonText: `确定`,
                    cancelButtonText: `取消`
                }).then(() => {
                    let req = this.myaxios.post(
                        `/api/Nursing/Charge/SubmitWithdraw?surgeryId=${this.surgeryId}&chargeType=${this.chargeType}&chargeRefundType=1`,
                        []
                    )
                    req.then(() => {
                        this.$message.success(`已发送`)
                        this.loadChargeItems()
                    })
                }).catch(() => {})
            } else {
                let selectRows = this.$refs.custtb.getSelectedRows()
                let data1 = _.filter(selectRows, d => d.enum_charge_status == 10 && d.enum_fee_type == 1) // 收费+待审核
                if (!data1 || data1.length == 0) {
                    this.$message.warning(`没有可以撤销的数据`)
                    return
                }
                this.$confirm(`是否确认撤销?`, `撤销操作`, {
                    confirmButtonText: `确定`,
                    cancelButtonText: `取消`
                }).then(() => {
                    let req = this.myaxios.post(
                        `/api/Nursing/Charge/SubmitWithdraw?surgeryId=${this.surgeryId}&chargeType=${this.chargeType}&chargeRefundType=${this.chargeRefundType}`,
                        _.map(data1, d => d.id)
                    )
                    req.then(() => {
                        this.$message.success(`已发送`)
                        this.loadChargeItems()
                    })
                }).catch(() => {})
            }
        },
        loadReturnCharges() {
            if (this.chargeRefundType == 1) {
                this.$confirm(`是否确认退费?`, `退费操作`, {
                    confirmButtonText: `确定`,
                    cancelButtonText: `取消`
                }).then(() => {
                    this.myaxios.post(
                        `/api/Nursing/Charge/SubmitTF?surgeryId=${this.surgeryId}&chargeType=${this.chargeType}&chargeRefundType=1`,
                        []
                    ).then(res => {
                        if (res && res != ``) {
                            this.$alert(res, `提醒`, {
                                dangerouslyUseHTMLString: true,
                                type: `warning`
                            }).then(data => {
                                this.loadChargeItems()
                            }).catch(this.loadChargeItems())
                            return
                        }
                        this.$message.success(`已发送`)
                        this.loadChargeItems()
                    })
                }).catch(() => {})
            } else {
                let selectRows = this.$refs.custtb.getSelectedRows()
                let data1 = _.filter(selectRows, d => (d.enum_charge_status == 1 || d.enum_charge_status == 4) && d.enum_fee_type == 1) // 收费+计费成功
                if (!data1 || data1.length == 0) {
                    this.$message.warning(`未找到可以退费的数据`)
                    return
                }
                this.$confirm(`是否确认退费?`, `退费操作`, {
                    confirmButtonText: `确定`,
                    cancelButtonText: `取消`
                }).then(() => {
                    let req = this.myaxios.post(
                        `/api/Nursing/Charge/SubmitTF?surgeryId=${this.surgeryId}&chargeType=${this.chargeType}&chargeRefundType=${this.chargeRefundType}`,
                        _.map(data1, d => d.id)
                    )
                    req.then((res) => {
                        if (res && res != ``) {
                            this.$alert(res, `提醒`, {
                                dangerouslyUseHTMLString: true,
                                type: `warning`
                            }).then(data => {
                                this.loadChargeItems()
                            }).catch(this.loadChargeItems())
                            return
                        }
                        this.$message.success(`已发送`)
                        this.loadChargeItems()
                    })
                }).catch(() => {})
            }
        },
        loadConfigs() {
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/Config/Get`)
                let req2 = this.myaxios.get(`/api/AcisSystem/AdditionalType/Get`)
                this.myaxios.all(req, req2).then(([data, data2]) => {
                    this.additional_types = data2
                    let refundType = _.filter(data, { key: `ChargeRefundType` })[0] && _.filter(data, { key: `ChargeRefundType` })[0].value
                    if (refundType) {
                        this.chargeRefundType = refundType
                    }
                    let config = _.filter(data, { key: `ChargeItemCodeConfig` })[0] && _.filter(data, { key: `ChargeItemCodeConfig` })[0].value
                    this.item_configs = config.split(`|`)
                    let selectedConfig = _.filter(data, { key: `ChargeTemplateSelected` })[0] && _.filter(data, { key: `ChargeTemplateSelected` })[0].value
                    if (selectedConfig) {
                        this.charge_template_selected = selectedConfig
                    }
                    this.setChargeColumns()
                    resolve()
                })
            })
        },
        setChargeColumns() {
            let that = this
            let resultColumns = [
                { prop: `name`, label: `项目名称`, minWidth: 250, fixed: `left` }
            ]
            that.item_configs.forEach(item => {
                let codeInfo = _.find(that.chargeColumns, { id: item })
                if (codeInfo) {
                    resultColumns.push(codeInfo)
                }
            })
            console.log(resultColumns)
            this.chargeColumns = resultColumns
        },
        loadChargeItemList(q, row) {
            let that = this
            let itemTypeId = 0
            let level = 0
            if (!this.isParent(row)) {
                level = 2
                itemTypeId = 7
            }
            return new Promise(resolve => {
                let req = this.myaxios.get(`api/AcisSystem/ChargeItem/SearchForChargeNewProc?keyword=${q && q.keyword}&level=${level}&itemTypeId=${itemTypeId}&surgeryId=${that.surgeryId}`)
                req.then(data => {
                    let result = []
                    if (data) {
                        data.forEach(d => {
                            let codes = []
                            // (0-编码,1-规格,2-价格,3-单位,4-厂商,5-统一收费编码,6-医保类型,7-库存,8-描述)
                            for (let item of this.item_configs) {
                                if (item === `0`) {
                                    codes.push(d.code)
                                }
                                if (item === `1`) {
                                    codes.push(d.spec || `--`)
                                }
                                if (item === `2`) {
                                    codes.push(d.price || `--`)
                                }
                                if (item === `3`) {
                                    codes.push(d.sell_unit || `--`)
                                }
                                if (item === `4`) {
                                    codes.push(d.firm || `--`)
                                }
                                if (item === `5`) {
                                    codes.push(d.uni_charge_code || `--`)
                                }
                                if (item === `6`) {
                                    codes.push(d.medical_type || `--`)
                                }
                                if (item === `7`) {
                                    codes.push(`库存:${d.inventory || `--`}`)
                                }
                                if (item === `8`) {
                                    codes.push(d.description || `--`)
                                }
                            }
                            let obj = {
                                ...d,
                                value: d.id,
                                label: d.name,
                                abbr: d.abbr,
                                code: codes.join(`/`)
                            }
                            result.push(obj)
                        })
                    }
                    resolve(result)
                })
            })
        },
        loadWorker(q, row) {
            // todo:是否需要判断手术区的员工
            let r = {
                // operatingWardId: (this.active_ward && this.active_ward.value.split(`_`)[1]),
                operatingWardId: 0,
                keyword: q && q.keyword
            }
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/Worker/SearchForChargeNew`, r)
                req.then(data => {
                    console.log(`SearchForChargeNew`)
                    console.log(data)
                    resolve(data)
                })
            })
        },
        loadSections(q, row) {
            let r = {
                keyword: q && q.keyword
            }
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/section/search`, r)
                req.then(data => {
                    resolve(data)
                })
            })
        },
        LoadUserColumns() {
            let that = this
            let req = this.myaxios.get(`api/AcisSystem/SystemServer/GetColumnConfig?tableName=${that.tableName}`)
            req.then(data => {
                let lcs = _.orderBy(this.columnList, function(lc) {
                    return _.findIndex(data, { col_name: lc.prop })
                })

                this.configColumns = lcs.filter(d => {
                    return d.label != `unique` && d.isListable !== false
                }).map(c => {
                    return { value: c.prop, label: c.label }
                })
                this.user_config_columns = (data && _.filter(data, { enabled: true }).map(d => d.col_name)) || []
                this.user_config_columns2 = data && _.filter(data, { enabled: true }).map(d => {
                    return {
                        col_name: d.col_name,
                        col_width: d.col_width
                    }
                }) || []
                this.$nextTick(() => {
                    let chks = this.$refs.configColumnRef.$el.querySelectorAll(`.el-checkbox`)
                    for (let i = chks.length - 1; i >= 0; i--) {
                        let chk = chks[i]
                        if (chk.innerText == `操作`) {
                            chk.style.display = `none`
                            break
                        }
                    }
                })
            })
        },
        SaveUserColumns() {
            let that = this
            let uc = this.configColumns.map((c, index) => {
                return {
                    col_name: c.value,
                    display_order: index,
                    enabled: _.includes(this.user_config_columns, c.value),
                    table_name: that.tableName
                }
            })
            let req = this.myaxios.post(`/api/AcisSystem/SystemServer/SetColumnConfig`, uc)
            req.then(data => {
                this.$message.success(`保存成功`)
                if (this.reload) {
                    this.reload()
                }
            }).catch(e => {})
        },
        configColumnDrop() {
            // if (!this.columnConfig) return
            const tbody = document.querySelector(`.config-column .el-checkbox-group`)
            const _this = this
            Sortable.create(tbody, {
                group: { name: `config-columns`, push: false, put: false },
                animation: 180,
                fallbackOnBody: true,
                delay: 0,
                onUpdate({ newIndex, oldIndex }) {
                    // 交换排序
                    if (newIndex == oldIndex) return
                    // console.log({ newIndex, oldIndex })
                    const currRow = _this.configColumns.splice(oldIndex, 1)[0]
                    _this.configColumns.splice(newIndex, 0, currRow)
                }
            })
        },
        getAllData() {
            var arr = []
            this.datalist.forEach(x => {
                if (!x.readonly) {
                    arr.push(x)
                    if (x.children && x.children.length > 0) {
                        x.children.forEach(y => {
                            arr.push(y)
                        })
                    }
                }
            })
            return arr
        },
        getPreData(row) {
            var alldata = this.getAllData()
            if (alldata.length <= 1) return undefined
            if (this.defaultPrevRow == `0`) {
                for (var i = alldata.length - 2; i >= 0; i--) {
                    let cur = alldata[i]
                    if (cur.dic_chrg_item_type_id == row.dic_chrg_item_type_id) {
                        return cur
                    }
                }
            } else {
                let predata = alldata[alldata.length - 2]
                return predata
            }
            return undefined
        },
        getIndex(id) {
            let index = 0
            for (let x of this.datalist) {
                if (x.id == id) {
                    return index
                }
                index++
                if (!x.readonly && x.children && x.children.length > 0) {
                    for (let ch of x.children) {
                        if (ch.id == id) {
                            return index
                        }
                        index++
                    }
                }
            }
            return -1
        },
        getAdd(savedata) {
            var arr = []
            savedata.forEach(d => {
                if (!d.id || d.id < 0 || d.rowStatus == 1) {
                    if (!d.modifier) d.modifier = ``
                    arr.push({
                        id: 0,
                        biz_surgery_info_id: this.surgeryId,
                        enum_charge_type: this.chargeType,
                        enum_fee_type: d.enum_fee_type,
                        enum_charge_status: d.enum_charge_status,
                        enum_pay_type: d.enum_pay_type,
                        dic_chrg_item_id: d.chrg_item.value,
                        amount: d.amount,
                        price: d.price,
                        billing_dept: d.billing_dept && d.billing_dept.value,
                        execute_dept: d.execute_dept && d.execute_dept.value,
                        remark: d.remark,
                        remark_msg: d.remark_msg,
                        modifier: _.isString(d.modifier) ? d.modifier : d.modifier.label,
                        doctor: d.doctor && d.doctor.value,
                        additional_type: d.additional_type,
                        parent_id: d.parent_id,
                        item_name: d.chrg_item.label,
                        charg_rate: d.charg_rate,
                        total_price: d.total_price,
                        level: d.level,
                        display_order: d.display_order,
                        consumables_batch: d.consumables_batch,
                        dic_chrg_item_type_id: d.dic_chrg_item_type_id,
                        dic_add_drug_way_id: d.dic_add_drug_way_id,
                        is_special_medication: d.is_special_medication,
                        special_medication_remark: d.special_medication_remark,
                        billing_time: d.billing_time || this.$moment().format(`YYYY/MM/DD HH:mm`)
                    })
                }
            })
            return arr
        },
        getEdit(savedata) {
            var arr = []
            savedata.forEach(d => {
                if (d.rowStatus != 1 && (d.enum_charge_status == 0 || d.enum_charge_status == 2)) {
                    if (!d.modifier) d.modifier = ``
                    arr.push({
                        id: d.id,
                        // biz_surgery_info_id: this.surgeryId, 解决偶发性病人数据被覆盖了问题
                        // enum_charge_type: this.chargeType,
                        enum_fee_type: d.enum_fee_type,
                        enum_charge_status: d.enum_charge_status,
                        enum_pay_type: d.enum_pay_type,
                        dic_chrg_item_id: d.chrg_item.value,
                        amount: d.amount,
                        price: d.price,
                        billing_dept: d.billing_dept && d.billing_dept.value,
                        execute_dept: d.execute_dept && d.execute_dept.value,
                        remark: d.remark,
                        remark_msg: d.remark_msg,
                        modifier: _.isString(d.modifier) ? d.modifier : d.modifier.label,
                        doctor: d.doctor && d.doctor.value,
                        additional_type: d.additional_type,
                        parent_id: d.parent_id,
                        item_name: d.chrg_item.label,
                        charg_rate: d.charg_rate,
                        total_price: d.total_price,
                        level: d.level,
                        display_order: d.display_order,
                        consumables_batch: d.consumables_batch,
                        dic_chrg_item_type_id: d.dic_chrg_item_type_id,
                        dic_add_drug_way_id: d.dic_add_drug_way_id,
                        is_special_medication: d.is_special_medication,
                        special_medication_remark: d.special_medication_remark,
                        billing_time: d.billing_time || this.$moment().format(`YYYY/MM/DD HH:mm`)
                    })
                }
            })
            return arr
        },
        DisplayOrderNumber(str) {
            let that = this
            let r = _.find(that.charge_item_types, { value: str })
            return (r && r.display_order) || 10000
        },
        scanCharge() {
            let that = this
            var alldata = this.$refs.custtb.getAllData()
            var savedata = _.filter(alldata, d => d.chrg_item && d.chrg_item.value && (!d.id || d.id < 0))

            if (savedata.length > 0) {
                this.$message.warning(`请先保存计费项`)
                return
            }
            if (!that.scancode) {
                that.$message.warning(`请输入或扫码`)
                return
            }
            console.log(`条码扫码枪`)
            let predata = null
            if (this.defaultPrevRow > `0` && this.datalist.length >= 2) {
                let r = this.datalist[this.datalist.length - 2]
                if (this.defaultPrevRow == `1`) {
                    predata = {
                        billing_dept: r.billing_dept && r.billing_dept.value,
                        doctor: r.doctor && r.doctor.value
                    }
                } else if (this.defaultPrevRow == `2`) {
                    predata = {
                        billing_dept: r.billing_dept && r.billing_dept.value,
                        execute_dept: r.execute_dept && r.execute_dept.value,
                        doctor: r.doctor && r.doctor.value
                    }
                }
            }
            let req = that.myaxios.post(`/api/Nursing/Charge/ChargeScan?barcode=${that.scancode.trim()}&surgeryId=${that.surgeryId}&chargeType=${that.chargeType}`, predata)
            req.then(data => {
                that.scancode = ``
                that.loadChargeItems()
                that.$refs[`scan-code`].scan_val = ``
                that.$message.success(`扫码成功`)
                that.$nextTick(() => {
                    that.$refs[`custtb`].scrollToBottom()
                })
            }).catch(e => {
                that.$message.error(e)
            })
        },
        changeColWidthBody(nw, ow, col, evt) {
            if (nw < 20) {
                nw = 20
            } else if (nw > 500) {
                nw = 500
            }
            let r = {
                col_name: col.property,
                col_width: parseInt(nw),
                table_name: this.tableName
            }
            let req = this.myaxios.post(`/api/AcisSystem/SystemServer/SetColumnWidth`, r)
            req.then(data => {
                this.$message.success(`列宽调整成功`)
                // if (this.reload) {
                //     this.reload()
                // }
            }).catch(e => {})
        },
        changeColWidth(nw, ow, col, evt) {
            let that = this
            // 列宽值改变则post列宽
            if (this.user_config_columns2.length == 0) {
                let uc = this.configColumns.map((c, index) => {
                    return {
                        col_name: c.value,
                        display_order: index,
                        enabled: _.includes(this.user_config_columns, c.value),
                        table_name: this.tableName
                    }
                })
                let req = this.myaxios.post(`/api/AcisSystem/SystemServer/SetColumnConfig`, uc)
                req.then(data => {
                    that.LoadUserColumns().then(d => {
                        that.changeColWidthBody(nw, ow, col, evt)
                    })
                }).catch(e => { })
            } else {
                that.changeColWidthBody(nw, ow, col, evt)
            }
        }

    },
    watch: {
        $route: function(newUrl, oldUrl) {
            this.getReload()
        },
        'confirmer.dialogFormVisible': function(newval, oldval) {
            if (newval == false) {
                this.confirmer.data.uid = ``
                this.confirmer.data.pwd = ``
            }
        },
        'collectCharges.selected_template': function(newval, oldval) {
            // 加载已选模板详情
            if (!newval) return
            let that = this
            let req = that.myaxios.get(`/api/AcisSystem/ChargeTemplate/Get/${newval}`)
            req.then(template => {
                let r = _.map(template.items, d => {
                    d.enum_fee_type = 1
                    d.enum_charge_status = 0
                    d.total_price = 1.0 * d.charge_item.price
                    d.spec = d.charge_item.spec
                    d.firm = d.charge_item.firm
                    d.sell_unit = d.charge_item.sell_unit
                    d.price = d.charge_item.price
                    d.dic_chrg_item_type_id = d.charge_item && d.charge_item.dic_chrg_item_type_id
                    d.is_drug_type = d.charge_item && d.charge_item.is_drug_type
                    d.dic_chrg_item_type = d.charge_item && this.getChargeItemTypeName(d.charge_item.dic_chrg_item_type_id)
                    d.dic_chrg_item_name = d.charge_item.name
                    d.chrg_item = {
                        label: d.charge_item.name,
                        value: d.charge_item.id
                    }
                    d.rowStatus = 1
                    d.dic_section_id = d.dic_section_id
                    if (d.dic_section_id && d.dic_section_id > 0) {
                        d.execute_dept = this.getSectionById(d.dic_section_id)
                    }

                    d.id_guid = d.id_guid
                    d.parentid_guid = d.parentid_guid
                    d.level = d.charge_item.level
                    return d
                })
                let datalist = _.orderBy(r, `display_order`)

                that.collectCharges.datalist = this.$refs.tempItemsTree.toTree(datalist)
                this.$nextTick(function() {
                    if (this.charge_template_selected && this.charge_template_selected === `1`) {
                        this.$refs.tempItemsTree.selectAll(true)
                    }
                })
            })
        },
        charge_item_type: function() {
            this.loadChargeItems()
        },
        status: function() {
            this.loadChargeItems()
        },
        fee_type: function() {
            this.loadChargeItems()
        },
        region_type: function() {
            this.loadTemplatesView()
        }
    }
}
</script>
<style scoped lang="less">
.fontredtip td {
    color: rgb(252, 164, 164);
}
.fontbluetip td {
    color: hsl(216deg 87% 69%);
}

.fontred td {
    color: red;
}
.fontorange td {
    color: orange;
}
.fontyellow td {
    color: yellow;
}
.fontgreen td {
    color: green;
}
.fontCyan td {
    color: Cyan;
}
.fontblue td {
    color: blue;
}
.fontpurple td {
    color: purple;
}
.el-table /deep/ .charge-row {
    color: var(--rowcolor) !important;
    background: var(--rowbgcolor) !important;
    font-weight: bold;
    &:hover {
        color: var(--hoverRowcolor) !important;
        background: var(--hoverRowbgcolor) !important;
        font-weight: bold;
    }
    .special_medication_remark {
        color: red !important;
        input {
                color: red !important;
        }
    }
}
.el-table /deep/ .fontYP {
    color: var(--YPColor) !important;
}
.el-table /deep/ .fontZL {
    color: var(--ZLColor) !important;
}
.el-table /deep/ .fontQT {
    color: var(--QTColor) !important;
}
.el-table /deep/ .fontHY {
    color: var(--HYColor) !important;
}
.el-table /deep/ .fontJC {
    color: var(--JCColor) !important;
}
.el-table /deep/ .fontZC {
    color: var(--ZCColor) !important;
}
.el-table /deep/ .fontSS {
    color: var(--SSColor) !important;
}
.el-table /deep/ .fontXF {
    color: var(--XFColor) !important;
}
.el-table /deep/ .fontCL {
    color: var(--CLColor) !important;
}
.el-table /deep/ .fontHL {
    color: var(--HLColor) !important;
}
.el-table /deep/ .fontDZHC {
    color: var(--DZHCColor) !important;
}
.el-table /deep/ .fontFYP {
    color: var(--FYPColor) !important;
}
.el-table /deep/ .fontHC {
    color: var(--HCColor) !important;
}
.el-table /deep/ .fontGZHC {
    color: var(--GZHCColor) !important;
}

.el-table /deep/ .fontYPAmounOver .amount {
    color: var(--YPAmountColor) !important;
}
.el-table /deep/ .fontZLAmounOver .amount {
    color: var(--ZLAmountColor) !important;
}
.el-table /deep/ .fontQTAmounOver .amount {
    color: var(--QTAmountColor) !important;
}
.el-table /deep/ .fontHYAmounOver .amount {
    color: var(--HYAmountColor) !important;
}
.el-table /deep/ .fontJCAmounOver .amount {
    color: var(--JCAmountColor) !important;
}
.el-table /deep/ .fontZCAmounOver .amount {
    color: var(--ZCAmountColor) !important;
}
.el-table /deep/ .fontSSAmounOver .amount {
    color: var(--SSAmountColor) !important;
}
.el-table /deep/ .fontXFAmounOver .amount {
    color: var(--XFAmountColor) !important;
}
.el-table /deep/ .fontCLAmounOver .amount {
    color: var(--CLAmountColor) !important;
}
.el-table /deep/ .fontHLAmounOver .amount {
    color: var(--HLAmountColor) !important;
}
.el-table /deep/ .fontDZHCAmounOver .amount {
    color: var(--DZHCAmountColor) !important;
}
.el-table /deep/ .fontFYPAmounOver .amount {
    color: var(--FYPAmountColor) !important;
}
.el-table /deep/ .fontHCAmounOver .amount {
    color: var(--HCAmountColor) !important;
}
.el-table /deep/ .fontGZHCAmounOver .amount {
    color: var(--GZHCAmountColor) !important;
}

.el-table /deep/ .fontpayTypeNull {
    color: var(--payTypeNullColor) !important;
}
.el-table /deep/ .fontamountZero {
    color: var(--amountZeroColor) !important;
}
.el-table /deep/ .fontamounOver .amount {
    color: var(--amountOverColor) !important;
}

</style>



// WEBPACK FOOTER //
// src/components/Surgery/Charge/ChargeNew.vue